import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  sq: {
    translation: {
      nav: {
        services: "Shërbimet",
        pricing: "Çmimet",
        work: "Si punojmë",
        about: "Rreth nesh",
        contact: "Kontakt",
        start: "Fillo Projektin",
        tracker: "Templates",
        admin: "Admin",
      },
      hero: {
        badge: "AGJENCIA JUAJ DIGJITALE NË KOSOVË",
        title: "Web Dizajn dhe Krijim Uebfaqesh në Kosovë",
        sub: "Vizioni Digjital është agjenci e specializuar për web dizajn, zhvillim uebfaqesh, SEO, dhe zhvillim softueri. Me bazë në Mitrovicë, ne ndihmojmë bizneset e vogla, kompanitë, restorantet dhe organizatat në mbarë Kosovën të rriten online.",
        cta1: "Fillo Projektin",
        cta2: "Shiko Portfolion",
        cta1_start: "Kërko Ofertë",
        cta2_work: "Shiko Punën Tonë",
        trustLine: "✓ Konsultim Falas ✓ Dizajn Modern ✓ Optimizim Lokal për Kosovë",
      },
      socialProof: {
        trustedBy: "Të besuar nga:",
        stats:
          "25+ Projekte të Dorëzuara | 1 Vit Përvojë | 100% Kënaqësi e Klientëve",
      },
      leadMagnet: {
        title: "🎁 Auditimi Falas i Uebfaqes Për Ju",
        desc: "Do ta rishikojmë faqen tuaj dhe do t'ju tregojmë saktësisht se çfarë po ju kushton të humbisni klientë. Pa pagesë.",
        cta: "Merr Auditin Falas",
      },
      about: {
        title: "Rreth Nesh",
        myStory: "Historia e Vizioni Digjital",
        story:
          "Vizioni Digjital lindi me një besim të thjeshtë: mjetet digjitale të cilësisë së lartë duhet të jenë të qasshme për çdo biznes, jo vetëm për korporatat e mëdha. Duke u rritur si një kompani inovative, ne pamë një boshllëk të madh midis inovacionit teknologjik dhe zgjidhjeve digjitale në dispozicion për bizneset në rritje. Si një partner i përkushtuar, misioni ynë është të ofrojmë zhvillim uebi të avancuar dhe automatizim AI të nivelit të ekspertëve që ndihmon bizneset të lulëzojnë.",
        heroText:
          "Ne nuk ndërtojmë thjesht faqe interneti. Ne krijojmë përvoja digjitale, të zhvilluara me përpikëri për të lartësuar markën tuaj dhe për të nxitur rritje të qëndrueshme.",
        myMission: "Misioni Ynë",
        mission:
          "Të fuqizojmë bizneset duke ndërtuar baza digjitale të besueshme, të shkallëzueshme dhe moderne që funksionojnë vërtet.",
        videoTitle: "Video Prezantuese",
        teamTitle: "Ekipi Ynë",
        whyChooseUs: {
          title: "Ne Jemi Vizioni Digjital",
          desc: "Një ekip krijuesish, dizajnerësh dhe zhvilluesish të pasionuar për të ndërtuar produkte digjitale që bëjnë ndryshimin.",
          items: [
            "Ne ndërtojmë partneritete afatgjata",
            "Ne ofrojmë cilësi dhe rezultate",
            "Ne fokusohemi në rritje",
            "Ne gjithmonë jemi duke u përmirësuar",
          ],
          cta: "Rreth Nesh",
        },
        experience: {
          years: "+2",
          desc: "Vit Përvojë",
        },
      },
      work: {
        title: "Si Punojmë",
        subtitle:
          "Nga ideja te realiteti. Zbuloni procesin tonë transparent të zhvillimit dhe eksploroni standardin e cilësisë që ne ofrojmë.",
        process: {
          title: "Procesi Ynë i Zhvillimit me 4 Hapa",
          steps: [
            {
              title: "Zbulimi",
              desc: "Kuptimi i nevojave dhe qëllimeve specifike të biznesit tuaj.",
            },
            {
              title: "Dizajni",
              desc: "Krijimi i përvojës së përdoruesit dhe ndërfaqes vizuale.",
            },
            {
              title: "Zhvillimi",
              desc: "Ndërtimi i zgjidhjeve digjitale të forta, të sigurta dhe të shpejta.",
            },
            {
              title: "Lansimi dhe Mbështetja",
              desc: "Dalja live dhe sigurimi i performancës së vazhdueshme.",
            },
          ],
        },
        concept: {
          title: "Modelet Demo & Përvojat Live",
          subtitle:
            "Eksploroni shabllonët tanë të gatshëm dhe ndërveprues për prodhim. Përdorini ato si një bazë të fuqishme për të lançuar aplikacionet tuaja të uebit ose zgjidhjet e personalizuara në kohë rekord.",
          items: [
            {
              title: "Dashboard Administrativ SaaS",
              desc: "Një panel i sofistikuar analitike në kohë reale i ndërtuar me grafikë të shpejtë të React dhe rrjeta statistikash responsive.",
            },
            {
              title: "Asistent Chat me Inteligjencë Artificiale",
              desc: "Një modul bisede plotësisht i përgjegjshëm, i zhvilluar rreth integrimeve të avancuara të AI dhe bisedës interaktive.",
            },
            {
              title: "E-Commerce dhe Dyqan Premium",
              desc: "Një strukturë e plotë shitjeje me pakicë e fokusuar në shpejtësinë absolute, konvertimet dhe përvojën e lehtë të pagesës.",
            },
          ],
          disclaimer: "Template Demo",
          exploreTemplates: "Eksploroni Templates Tona →",
          processBadge: "Shabllonët & Demo",
          featured: "E përzgjedhur",
        },
        cta: {
          title: "Projekti juaj i parë?",
          text: "Pasi po ndërtoj bazën e klientëve të mi, ofroj vëmendje shtesë dhe çmime me zbritje për klientët e parë. Le të ndërtojmë diçka të mrekullueshme së bashku.",
          button: "Merr Vëmendje Eksperti",
        },
        portfolio: {
          title: "Portofoli Ynë",
          subtitle: "Punë që flasin vetë",
          viewAll: "Shiko të gjitha",
        },
      },
      contact: {
        title: "Gati Për Rritje? Le Të Flasim.",
        desc: "Ne përgjigjemi brenda 24 orëve.",
        form: {
          name: "Emri",
          email: "Email",
          message: "Na tregoni rreth projektit tuaj",
          namePlaceholder: "Shënoni emrin tuaj...",
          emailPlaceholder: "email@shembull.com",
          messagePlaceholder: "Na tregoni më shumë për projektin tuaj...",
          submit: "Dërgo Mesazhin",
          success: "Mesazhi u dërgua!",
          successDesc:
            "Ju faleminderit që na kontaktuat. Ne do t'ju përgjigjemi sa më shpejt që të jetë e mundur.",
          sendAnother: "Dërgo një tjetër",
        },
        whatsapp: "Bisedo në WhatsApp",
        location: "Dizajn & Zhvillim Softuerik",
      },
      servicesPage: {
        badge: "Ndërtojmë të Ardhmen",
        title: "Përsosmëri Digjitale<br /> e Dëshmuar.",
        subtitle:
          "Ne kthejmë idetë tuaja në realitet me teknologjinë më të fundit, dizajn të jashtëzakonshëm dhe zhvillim softuerik të testuar.",
        ctaTitle: "Gati për të transformuar prezencën tuaj digjitale?",
        ctaViewWork: "Shiko Punimet Tona",
        ctaStart: "Fillo Një Projekt",
        items: [
          {
            title: "Dizajn UI/UX & Uebfaqe",
            desc: "Ndërfaqe digjitale mahnitëse dhe plotësisht të personalizuara. Nuk ndërtojmë thjesht uebfaqe; krijojmë eksperienca vizuale që kthejnë vizitorët në klientë besnikë.",
            tags: [
              "Prototiping në Figma",
              "Identitet Brandi",
              "Dizajn Interaktiv",
              "Strukturë Responsive",
            ],
            features: [
              "Dizajn Vizual Perfekt",
              "Arkitekturë Mobile-First",
              "Animacione dhe Elemente 3D",
              "Landing Pages për Konvertime",
            ],
          },
          {
            title: "Zhvillim Custom Ueb & App",
            desc: "Aplikacione ueb dhe mobile të shpejta, të sigurta dhe të shkallëzueshme. Ndërtojmë me teknologjitë e fundit për të menaxhuar logjikë komplekse dhe trafik të lartë.",
            tags: [
              "React & Next.js",
              "Tailwind CSS",
              "TypeScript",
              "Node.js (Backend)",
            ],
            features: [
              "Aplikacione Ueb Full-Stack",
              "Platforma SaaS",
              "Progressive Web Apps (PWA)",
              "Arkitekturë e Sigurt e Databazës",
            ],
          },
          {
            title: "Integrime & Automatizime AI",
            desc: "Super-fuqizoni biznesin tuaj me Inteligjencën Artificiale. Integrojmë modele gjuhësore (LLMs), asistentë bisedash dhe automatizojmë procese për t'ju kursyer qindra orë punë e kohë.",
            tags: [
              "Integrim OpenAI / Gemini",
              "Bot-e për Procese",
              "Automatizim",
              "LangChain",
            ],
            features: [
              "ChatBots Inteligjentë",
              "Ekstraktim i Automatizuar i të Dhënave",
              "Gjenerim i Përmbajtjes me AI",
              "Analitikë Prediktive e Biznesit",
            ],
          },
          {
            title: "Zgjidhje Enterprise & E-Commerce",
            desc: "Dyqane online me performancë të lartë dhe sisteme të menaxhimit të biznesit. Të dizajnuara për sigurinë maksimale të transaksioneve dhe rritje pa ndërprerje.",
            tags: [
              "Shopify / Custom E-Comm",
              "Integrime Stripe",
              "Sisteme Inventari",
              "Performancë SEO",
            ],
            features: [
              "Platforma E-Commerce të Personalizuara",
              "Integrimi i Sigurt i Pagesave",
              "Optimizim i Avancuar SEO",
              "Hostim Cloud & Infrastrukturë",
            ],
          },
        ],
      },
      usecases: {
        title: "Zgjidhje sipas Industrisë",
        sub: "Ne zgjidhim probleme specifike për çdo industri.",
        items: [
          {
            title: "Restorante & Kafe",
            desc: "Menu digjitale, sisteme rezervimi dhe prezencë moderne ueb.",
          },
          {
            title: "E-Commerce",
            desc: "Dyqane online të shpejta që konvertojnë vizitorët në blerës.",
          },
          {
            title: "Biznes & Portfolio",
            desc: "Prezantim profesional i shërbimeve dhe punëve tuaja.",
          },
          {
            title: "SaaS & Teknologji",
            desc: "Zgjidhje softuerike të personalizuara për nevoja komplekse.",
          },
        ],
      },
      process: {
        title: "Si Punojmë",
        sub: "Një proces i thjeshtë, transparent për t'ju dhënë rezultate.",
        steps: [
          {
            title: "Ne Flasim",
            desc: "Telefonatë falas 30-min për të kuptuar qëllimet tuaja.",
          },
          {
            title: "Ne Ndërtojmë",
            desc: "Ekipi ynë dizajnon dhe zhvillon zgjidhjen tuaj.",
          },
          {
            title: "Ju Rriteni",
            desc: "Lansojmë, optimizojmë dhe marrim rezultate reale.",
          },
        ],
      },
      pricing: {
        title: "Planet Tona",
        sub: "Zgjidhni planin që i përshtatet rritjes suaj digjitale.",
        launch: "Launch",
        launchDesc: "Ideale për prezantim fillestar dhe bizneset e reja.",
        growth: "Growth",
        growthDesc: "E përkryer për biznese që kërkojnë rritje dhe ndërveprim.",
        enterprise: "Enterprise",
        enterpriseDesc:
          "Zgjidhje komplekse dhe të automatizuara për korporata.",
        features: {
          onePage: "Uebfaqe me një faqe (One Page)",
          maps: "Integrimi i Google Maps",
          basicSeo: "SEO Bazë",
          multiPage: "Deri në 5 Faqe",
          whatsapp: "Butoni WhatsApp",
          advSeo: "SEO e Avancuar",
          ecommerce: "Dyqan Online (E-commerce)",
          mobileApp: "Aplikacion Mobile",
          aiChatbot: "Chatbot AI Personal",
        },
        maint: "Planet e mirëmbajtjes nga 49€ në muaj",
        cta: "Fillo Faqen Tënde",
        refund:
          "* Rimbursim i plotë nëse nuk jeni të kënaqur me rezultatin final.",
        pricingPage: {
          title: "Planet Tona",
          subtitle: "Zgjidhni planin që i përshtatet biznesit tuaj.",
          demoCta: "Demo falas",
          mostPopular: "Më i kërkuari",
          footerLines: [
            "Domain-i blihet nga ju në Porkbun (ose ne e blejmë për ju me kosto shtesë 15€/vit).",
            "Çmimet përfshijnë ndërtimin fillestar. Ndryshimet e mëdha strukturore pas dorëzimit nuk janë të përfshira në mirëmbajtjen mujore, por mund të ofrohen me çmim të veçantë.",
          ],
          launchquote:
            "“Fillimi perfekt për një biznes që do praninë e parë online.”",
          launchheader: "Çfarë përfshin vërtet",
          growthquote:
            "“Për bizneset që duan më shumë faqe dhe ndërveprim direkt me klientët.”",
          growthheader: "Çfarë përfshin vërtet",
          enterprisequote:
            "“Zgjidhje e plotë për bizneset që duan automatizim dhe shitje online.”",
          enterpriseheader: "Çfarë përfshin vërtet",
          launchfeat1Title: "Uebfaqe me një faqe (One Page)",
          launchfeat1Desc:
            "Dizajn modern, i personalizuar me ngjyrat dhe logon tënde. E përshtatur për celular dhe tablet. Përmban: kreu, rreth nesh, shërbimet, galeria dhe kontakti — gjithçka në një faqe të vetme.",
          launchfeat2Title: "Integrimi i Google Maps",
          launchfeat2Desc:
            "Harta e saktë e lokacionit tënd e vendosur në faqe. Klientët gjejnë rrugën me një klik.",
          launchfeat3Title: "SEO Bazë",
          launchfeat3Desc:
            "Titulli dhe përshkrimi i optimizuar për Google, fjalët kyçe kryesore, lidhja me Google My Business dhe faqja e regjistruar në Google Search Console.",
          launchfeat4Title: "Formular kontakti",
          launchfeat4Desc:
            "Një formular i thjeshtë që dërgon mesazhet direkt në emailin tënd. Pa limit.",
          launchfeat5Title: "Asistencë në lidhjen e domain-it",
          launchfeat5Desc:
            "Të ndihmojmë të blesh dhe të lidhësh domain-in tënd (psh. emri.com).",
          launchfeat6Title: "Mirëmbajtje opsionale 49€/muaj",
          launchfeat6Desc:
            "Përfshin: hostim të sigurt, përditësime teknike, backup ditor dhe deri në 2 ndryshime të vogla në muaj (tekst, foto, orar).",
          growthfeat1Title: "Deri në 5 faqe të personalizuara",
          growthfeat1Desc:
            "Për shembull: Ballina, Rreth Nesh, Shërbimet, Galeria, Kontakti. Çdo faqe e optimizuar dhe unike.",
          growthfeat2Title: "Butoni WhatsApp",
          growthfeat2Desc:
            "Një buton lundrues që i lejon klientët të të shkruajnë në WhatsApp me një klik, pa ruajtur numrin. Rrit ndjeshëm kërkesat.",
          growthfeat3Title: "SEO e Avancuar",
          growthfeat3Desc:
            "Hulumtim fjalesh kyçe lokale, optimizim i çdo faqeje, tituj unikë, meta përshkrime, strukturë URL miqësore dhe integrim me Google Analytics.",
          growthfeat4Title: "Dizajn i personalizuar me 2 xhiro rishikimesh",
          growthfeat4Desc:
            "Dërgon idetë e tua, ne i kthejmë në dizajn, dhe ke dy runde ndryshimesh derisa të jesh 100% i kënaqur.",
          growthfeat5Title: "Integrim i rrjeteve sociale",
          growthfeat5Desc:
            "Lidhje direkte me Instagramin, Facebook-un dhe TikTok-un tënd. Ikonat në faqe dhe opsion për të shfaqur feed-in e Instagramit.",
          growthfeat6Title: "Optimizim për shpejtësi dhe celular",
          growthfeat6Desc:
            "Faqja ngarkohet në më pak se 2 sekonda dhe duket perfekte në çdo ekran.",
          growthfeat7Title: "Mirëmbajtje opsionale 49€/muaj",
          growthfeat7Desc:
            "Përfshin: hostim, backup, përditësime sigurie, dhe deri në 4 ndryshime të vogla në muaj (p.sh. ndryshim çmimesh, foto të reja).",
          enterfeat1Title: "Dyqan Online (E-commerce)",
          enterfeat1Desc:
            "Shto deri në 50 produkte, menaxho stokun, prano porosi online. Integrim me pagesa lokale (p.sh. Paysera, banka) sipas marrëveshjes. Nuk ka komision mbi shitjet.",
          enterfeat2Title: "Aplikacion Mobile (PWA)",
          enterfeat2Desc:
            "Një version i faqes që instalohet në telefon si aplikacion, pa qenë nevoja të shkarkohet nga App Store. Punon offline dhe dërgon njoftime.",
          enterfeat3Title: "Chatbot AI Personal",
          enterfeat3Desc:
            "Asistent virtual që i përgjigjet pyetjeve të shpeshta të klientëve 24/7, merr porosi dhe rezervime automatike.",
          enterfeat4Title: "Rezervime / Booking System",
          enterfeat4Desc:
            "Sistem i plotë rezervimi. Klientët zgjedhin datën, orën dhe shërbimin; ti menaxhon gjithçka nga paneli yt i administratorit.",
          enterfeat5Title: "Panel administratori i personalizuar",
          enterfeat5Desc:
            "Kontroll i plotë mbi përmbajtjen, produktet, porositë dhe klientët pa pasur nevojë për kodim.",
          enterfeat6Title: "SEO Premium dhe raportim mujor",
          enterfeat6Desc:
            "Optimizim i thellë teknik, raport mujor me grafikë mbi vizitorët dhe sugjerime për përmirësim.",
          enterfeat7Title: "Trajnim 1-orësh për stafin tënd",
          enterfeat7Desc:
            "Të mësojmë si të përdorësh panelin dhe si të shtosh përmbajtje vetë.",
          enterfeat8Title: "Mirëmbajtje opsionale 49€/muaj",
          enterfeat8Desc:
            "Përfshin: hostim premium, backup ditor, monitorim 24/7, përditësime të rregullta dhe deri në 6 ndryshime të vogla në muaj.",
        },
      },
      faqs: {
        title: "Pyetjet e Shpeshta",
        sub: "Gjithçka që ju duhet të dini për të filluar.",
        items: [
          {
            q: "Sa kohë merr ndërtimi i një uebfaqeje?",
            a: "Për projektet bazë, koha mesatare është 7-10 ditë. Projektet më komplekse mund të marrin 3-6 javë.",
          },
          {
            q: "A ofroni mirëmbajtje pas përfundimit?",
            a: "Po, ne ofrojmë plane mirëmbajtjeje mujore që sigurojnë që uebfaqja juaj të jetë gjithmonë e përditësuar dhe e sigurt.",
          },
          {
            q: "A mund ta ndryshoj përmbajtjen vetë?",
            a: "Sigurisht. Çdo uebfaqe vjen me një panel administrimi të thjeshtë ku mund të bëni ndryshime pa pasur nevojë për kodim.",
          },
          {
            q: "A janë uebfaqet tuaja të optimizuara për Google?",
            a: "Po, SEO (Search Engine Optimization) është pjesë integrale e çdo projekti që ne ndërtojmë.",
          },
          {
            q: "Cila është politika e rimbursimit?",
            a: "Në Vizioni Digjital, ne ofrojmë rimbursim të plotë nëse dështojmë të dorëzojmë projektin sipas specifikave të rëna dakord.",
          },
        ],
      },
      testimonials: {
        title: "Çfarë thonë klientët tanë",
        sub: "Suksesi juaj është dëshmia jonë më e mirë.",
        viewAll: "Shiko të gjitha dëshmitë",
        items: [
          {
            name: "Agim Krasniqi",
            role: "CEO, TechKos",
            text: "Vizioni Digjital e kuptoi saktësisht atë që na duhej. Uebfaqja jonë e re ka dyfishuar kontaktet tona në vetëm një muaj. Ekip shumë i përkushtuar!",
          },
          {
            name: "Besnik Hoxha",
            role: "Drejtor, AutoKosova",
            text: "Sistemi që na ndërtuan është tepër i shpejtë dhe i lehtë për t'u përdorur. Na ka kursyer orë të tëra pune çdo ditë dhe shitjet janë rritur ndjeshëm.",
          },
          {
            name: "Elena K.",
            role: "Themeluese, Boutique",
            text: "Dizajn i mrekullueshëm dhe optimizim i shkëlqyer për SEO. Klientët e rinj na gjejnë më lehtë se kurrë përmes kërkimeve në Google.",
          },
        ],
      },
      chat: {
        title: "Na Shkruani",
        name: "Emri",
        surname: "Mbiemri",
        username: "Përdoruesi",
        email: "Email",
        msg: "Si mund t'ju ndihmojmë?",
        sentAs: "Dërguar si:",
        screenshotLabel: "Opsionale: Shto Screenshot",
        uploadScreenshot: "Ngarko Foto",
        imageSelected: "Foto u zgjodh ✅",
        send: "Dërgo",
        sending: "Duke dërguar...",
        success: "Mesazhi u dërgua! 🚀",
        placeholder: "Pyet psh: 'Sa kushton plani Growth?'",
        aiTab: "Mbështetje AI",
        contactTab: "Na shkruani",
        badgeAi: "Asistent Digjital",
      },
      tracker: {
        title: "Trendet",
        titleAccent: "e Zhvillimit.",
        sub: "Zbuloni uebfaqet tona më të vlerësuara dhe produktet tona moderne të zhvillimit.",
        viewAll: "Shiko të gjitha",
        filters: {
          all: "Të gjitha",
          web: "Web",
          mobile: "Mobile",
          ai: "AI",
          restaurant: "Restorante & Kafe",
          ecommerce: "E-Commerce",
          business: "Biznes",
          portfolio: "Portfolio",
          templates: "Templates",
          branding: "Branding",
          design: "Design",
        },
        sort: {
          popular: "Më të Popullarizuarat",
          newest: "Më të Rejat",
          seo: "Vlerësimi SEO",
        },
        searchPlaceholder: "Kërko projekte ose shabllone...",
        noProjects: "Nuk u gjet asnjë projekt.",
        description: "Përshkrimi",
        reviews: "Vlerësimet",
        addReview: "Shto Vlerësim",
        noReviews: "Ende nuk ka vlerësime. Bëhu i pari!",
        rating: "Vlerësimi",
        commentPlaceholder: "Shkruani mendimet tuaja...",
        send: "Dërgo",
        cancel: "Anulo",
        loginToLike: "Ju lutemi hyni për të pëlqyer.",
        loginToReview: "Ju lutemi hyni për të vlerësuar.",
        iframeWarning: {
          title: "Problem me pamjen?",
          text: "Nëse faqja nuk ngarkohet më lart, platformat e sigurisë mund të bllokojnë integrimin (iFrame).",
          link: "Kliko këtu për ta parë direkt.",
        },
        livePreview: {
          title: "Live Preview",
          note: "Dizajni i uebfaqes mund të ndryshojë brenda kornizës.",
        },
      },
      insights: {
        title: "Blogu Ynë",
        subtitle: "Insights & Artikuj Që Ju Inspirojnë",
        viewAll: "Shiko të gjitha",
        readOtherArticles: "Lexo artikuj të tjerë",
        articles: [
          {
            title: "10 Trendet e Dizajnit Ueb për 2024",
            date: "10 Maj, 2024",
            tag: "DIZAJN WEB",
          },
          {
            title: "Si ta Rritni Brendin tuaj në Rrjetet Sociale",
            date: "8 Maj, 2024",
            tag: "MARKETING",
          },
          {
            title: "Praktikat më të mira të SEO për Renditje më të Lartë",
            date: "3 Maj, 2024",
            tag: "SEO",
          },
        ],
      },
      profile: {
        title: "Profili Im",
        logout: "Dil",
        myProjects: "Projektet e Mia",
        publishProject: "Publiko Projekt",
        noProjects: "Ende nuk keni publikuar asnjë projekt.",
        deleteConfirm: "A jeni i sigurt që dëshironi të fshini këtë projekt?",
        yesDelete: "Po, Fshij",
        cancel: "Anulo",
        subDetails: "Detajet e Abonimit",
        status: "Statusi",
        active: "Aktiv",
        inactive: "Joaktiv",
        expires: "Skadon më",
        noExpiry: "Pa skadim",
        wantMore: "Dëshironi më shumë?",
        upgradeSub:
          "Përmirësoni planin tuaj për të marrë vlerësim më të lartë SEO dhe mbështetje prioritare.",
        viewPlans: "Shiko Planet",
      },
      publish: {
        title: "Publiko",
        titleAccent: "Projektin Tënd.",
        projectTitle: "Titulli i Projektit",
        url: "URL e Uebfaqes",
        category: "Kategoria",
        description: "Përshkrimi i Shkurtër",
        submit: "Publiko Tani",
        submitting: "Duke publikuar...",
        placeholderTitle: "p.sh. Dyqani im Online",
        placeholderUrl: "https://uebfaqja-jote.com",
      },
      subscription: {
        notification: "Njoftim Abonimi",
        expiresTomorrow:
          "Abonimi juaj skadon nesër! Ju lutemi rinovoni për të vazhduar shërbimin.",
        expiresInDays: "Abonimi juaj skadon pas {{days}} ditësh.",
        expired:
          "Abonimi juaj ka skaduar. Ju lutemi kontaktoni stafin për rinovim.",
        renewNow: "Rinovoni Tani",
      },
      common: {
        login: "Kyçu",
        loginToView: "Ju lutemi kyçuni për të parë këtë faqe.",
        loading: "Duke u ngarkuar...",
        error: "Gabim",
        success: "Sukses",
        anonymous: "Anonim",
      },
      seo: {
        defaultTitle:
          "Vizioni Digjital | Ndërtim Uebfaqesh Kosovë & Zhvillim Softueri me Porosi",
        homeDesc:
          "Vizioni Digjital është agjencia lider për ndërtim uebfaqesh dhe zhvillim softueri me porosi në Kosovë. Krijojmë dyqane online e-commerce të optimizuara për SEO dhe sisteme moderne.",
        homeKeywords:
          "ndertim uebfaqesh kosove, krijim uebfaqe prishtine, zhvillim softueri me porosi, dizajn uebfaqesh, optimizim seo kosove, kompani softuerike, dyqane online, vizioni digjital",
        aboutTitle: "Rreth Nesh",
        aboutDesc:
          "Mësoni historinë e Vizioni Digjital dhe misionin tonë si agjenci teknologjike.",
        workTitle: "Si Punojmë (How We Work)",
        workDesc:
          "Zbuloni procesin tonë transparent të zhvillimit me 4 hapa dhe eksploroni projektet tona.",
        contactTitle: "Kontakt",
        contactDesc:
          "Na kontaktoni për zhvillim ekspert të uebit, integrime sistemesh dhe zgjidhje AI.",
        servicesTitle: "Shërbimet",
        servicesDesc:
          "Dizajn profesional ueb, aplikacione mobile dhe automatizim AI i përshtatur për biznesin tuaj.",
        pricingTitle: "Planet & Çmimet",
        pricingDesc:
          "Zgjidhni planin ideal për biznesin tuaj. Nga paketat bazë deri te zgjidhjet e avancuara Enterprise.",
        templatesTitle: "Shabllonet & Sistemet tona",
        templatesDesc:
          "Shfletoni bibliotekën tonë të shablloneve premium dhe sistemeve të gatshme për biznese.",
        blogTitle: "Blogu & Insights",
        blogDesc:
          "Lajmet e fundit nga teknologjia, këshilla për SEO dhe strategji për rritje digjitale.",
        privacyTitle: "Politika e Privatësisë",
        termsTitle: "Kushtet e Përdorimit",
        refundTitle: "Politika e Rimbursimit",
        legalDesc:
          "Lexoni {{title}} e Vizioni Digjital. Ne jemi të përkushtuar ndaj transparencës dhe sigurisë.",
      },
      admin: {
        title: "Admin",
        titleAccent: "Dashboard.",
        logout: "Log Out",
        accessDenied: "Qasja u Refuzua",
        accessDeniedSub: "Vetëm administratorët mund të shohin këtë faqe.",
        stats: {
          totalMessages: "Mesazhe",
          unread: "Të papara",
          liveProjects: "Projekte",
          paymentConfirmations: "Pagesat",
        },
        tabs: {
          messages: "Mesazhet",
          projects: "Projektet",
          users: "Përdoruesit",
        },
        messages: {
          replyEmail: "Kthe Email",
          replySubject: "Përgjigje nga Vizioni Digjital",
          replyBody: "Përshëndetje {{name}},...",
          confirmPayment: "Konfirmo Pagesën",
          paymentSubject: "Konfirmim i Pagesës - Vizioni Digjital",
          paymentText:
            "Përshëndetje {{name}}, pagesa juaj u konfirmua me sukses.",
          markAsRead: "Shëno si të lexuar",
          markAsUnread: "Shëno si të palexuar",
          delete: "Fshij",
          confirmDelete: "Konfirmo Fshirjen",
          cancel: "Anulo",
          screenshotConfirmation: "Konfirmimi me Foto",
        },
        addProject: {
          title: "Shto Projekt",
          submit: "Ruaj",
        },
        users: {
          plan: "Plani",
          expiry: "Skadimi",
          status: "Statusi",
          save: "Ruaj",
        },
      },
      legal: {
        privacy: {
          title: "Politika e Privatësisë",
          content: `
            <div class="prose prose-invert max-w-none">
              <h2>1. Hyrje</h2>
              <p>Mirë se vini në Vizioni Digjital. Ne jemi të përkushtuar të mbrojmë privatësinë tuaj dhe të dhënat tuaja personale. Kjo politikë e privatësisë ju informon se si ne kujdesemi për të dhënat tuaja personale kur vizitoni faqen tonë të internetit dhe ju tregon për të drejtat tuaja të privatësisë.</p>

              <h2>2. Të Dhënat që Mbledhim</h2>
              <p>Ne mund të mbledhim, përdorim, ruajmë dhe transferojmë lloje të ndryshme të të dhënave personale rreth jush, duke përfshirë:</p>
              <ul>
                <li><strong>Të dhënat e identifikimit:</strong> Emri, mbiemri, emri i përdoruesit ose identifikuesi i ngjashëm.</li>
                <li><strong>Të dhënat e kontaktit:</strong> Adresa e faturimit, adresa e emailit dhe numrat e telefonit.</li>
                <li><strong>Të dhënat teknike:</strong> Adresa e protokollit të internetit (IP), të dhënat tuaja të hyrjes, lloji dhe versioni i shfletuesit, vendndodhja dhe zona kohore, llojet dhe versionet e shtojcave të shfletuesit, sistemi operativ dhe platforma, dhe teknologji të tjera në pajisjet që përdorni për të hyrë në këtë faqe interneti.</li>
                <li><strong>Të dhënat e përdorimit:</strong> Informacion mbi mënyrën se si e përdorni faqen tonë të internetit, produktet dhe shërbimet tona.</li>
              </ul>

              <h2>3. Si i Përdorim Të Dhënat Tuaja</h2>
              <p>Ne do t'i përdorim të dhënat tuaja personale vetëm kur na lejon ligji. Më së shpeshti, ne do t'i përdorim të dhënat tuaja personale në rrethanat e mëposhtme:</p>
              <ul>
                <li>Kur duhet të përmbushim kontratën që jemi gati të lidhim ose kemi lidhur me ju.</li>
                <li>Kur është e nevojshme për interesat tona legjitime dhe interesat tuaja dhe të drejtat themelore nuk i tejkalojnë ato interesa.</li>
                <li>Kur duhet të zbatojmë një detyrim ligjor ose rregullator.</li>
              </ul>

              <h2>4. Siguria e të Dhënave</h2>
              <p>Ne kemi vendosur masa sigurie të përshtatshme për të parandaluar hupjen, përdorimin ose qasjen e paautorizuar në të dhënat tuaja personale, ndryshimin ose zbulimin e tyre. Për më tepër, ne kufizojmë qasjen në të dhënat tuaja personale vetëm për ata punonjës, agjentë dhe palë të treta që kanë një nevojë biznesi për t'i njohur ato.</p>

              <h2>5. Pagesat dhe Privatësia e Stripe</h2>
              <p>Ne përdorim <strong>Stripe</strong> për përpunimin e pagesave. Ne nuk ruajmë apo mbajmë të dhënat e kartës suaj të kreditit ose debitit në serverët tanë. Të gjitha informacionet e pagesave përpunohen dhe ruhen në mënyrë të sigurt nga Stripe. Duke përdorur shërbimet tona, ju pranoni gjithashtu politikën e privatësisë së Stripe, të cilën mund ta gjeni në <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">stripe.com/privacy</a>.</p>

              <h2>6. Ruajtja e të Dhënave</h2>
              <p>Ne do t'i ruajmë të dhënat tuaja personale vetëm për aq kohë sa është e nevojshme për të përmbushur qëllimet për të cilat i kemi mbledhur, duke përfshirë qëllimet e përmbushjes së çdo kërkese ligjore, kontabël ose raportimi.</p>

              <h2>7. Cookies dhe Google AdSense</h2>
              <p>Faqja jonë përdor "cookies" për të përmirësuar përvojën e përdoruesit. Ne mund të përdorim Google AdSense për të shfaqur reklama. Google, si një furnizues i palës së tretë, përdor cookies për të shfaqur reklama në faqen tonë. Përdorimi i kukit DART nga Google i mundëson asaj t'u shfaqë reklama përdoruesve tanë bazuar në vizitën e tyre në faqen tonë dhe faqe të tjera në internet.</p>

              <h2>8. Të Drejtat Tuaja</h2>
              <p>Në rrethana të caktuara, ju keni të drejta sipas ligjeve të mbrojtjes së të dhënave në lidhje me të dhënat tuaja personale, duke përfshirë të drejtën për të kërkuar qasje, korrigjim, fshirje, kufizim, transferueshmëri dhe të drejtën për të kundërshtuar përpunimin.</p>
            </div>
          `,
        },
        terms: {
          title: "Kushtet e Përdorimit",
          content: `
            <div class="prose prose-invert max-w-none">
              <h2>1. Pranimi i Kushteve</h2>
              <p>Duke hyrë dhe përdorur faqen e internetit të Vizioni Digjital, ju pranoni dhe pajtoheni të jeni të lidhur me kushtet dhe dispozitat e kësaj marrëveshjeje. Nëse nuk pajtoheni me këto kushte, ju lutemi mos e përdorni shërbimin tonë.</p>

              <h2>2. Përshkrimi i Shërbimit</h2>
              <p>Vizioni Digjital ofron shërbime të zhvillimit të uebit, aplikacioneve mobile, dizajnit grafik dhe zgjidhjeve të Inteligjencës Artificiale. Ne rezervojmë të drejtën për të modifikuar ose ndërprerë shërbimin me ose pa paralajmërim.</p>

              <h2>3. Përgjegjësitë e Përdoruesit</h2>
              <p>Si përdorues, ju jeni përgjegjës për ruajtjen e konfidencialitetit të llogarisë tuaj dhe fjalëkalimit. Ju pranoni të njoftoni menjëherë Vizioni Digjital për çdo përdorim të paautorizuar të llogarisë tuaj.</p>

              <h2>4. Pronësia Intelektuale</h2>
              <p>E gjithë përmbajtja e përfshirë në këtë faqe, si teksti, grafika, logot, ikonat e butonave, imazhet dhe softueri, është pronë e Vizioni Digjital ose e furnizuesve të saj të përmbajtjes dhe mbrohet nga ligjet ndërkombëtare të të drejtave të autorit.</p>

              <h2>5. Kufizimi i Përgjegjësisë</h2>
              <p>Vizioni Digjital nuk do të jetë përgjegjës për asnjë dëm të drejtpërdrejtë, të tërthortë, të rastësishëm, pasues ose shembullor që rrjedh nga përdorimi ose pamundësia për të përdorur shërbimin tonë.</p>

              <h2>6. Ndryshimet në Kushtet</h2>
              <p>Ne rezervojmë të drejtën të ndryshojmë këto kushte në çdo kohë. Përdorimi i vazhdueshëm i faqes pas çdo ndryshimi të tillë përbën pranimin tuaj të kushteve të reja.</p>

              <h2>7. Ligji i Zbatueshëm</h2>
              <p>Këto kushte do të rregullohen dhe interpretohen në përputhje me ligjet e Republikës së Shqipërisë dhe Kosovës, pa marrë parasysh konfliktin e dispozitave ligjore.</p>
            </div>
          `,
        },
        refund: {
          title: "Politika e Rimbursimit",
          content: `
            <div class="prose prose-invert max-w-none">
              <h2>1. Politika e Përgjithshme</h2>
              <p>Në Vizioni Digjital, ne synojmë të ofrojmë shërbime të cilësisë më të lartë. Megjithatë, ne e kuptojmë se mund të ketë rrethana ku nevojitet një rimbursim.</p>

              <h2>2. Shërbimet e Zhvillimit (Web & Apps)</h2>
              <p>Për shkak të natyrës së shërbimeve të personalizuara të zhvillimit, rimbursimet procedohen si vijon:</p>
              <ul>
                <li><strong>Para fillimit të punës:</strong> Rimbursim i plotë 100%.</li>
                <li><strong>Gjatë fazës së dizajnit:</strong> Rimbursim deri në 50% të shumës së paguar.</li>
                <li><strong>Pas fillimit të zhvillimit të kodit:</strong> Nuk ofrohen rimbursime për shkak të orëve të punës të angazhuara.</li>
              </ul>

              <h2>3. Produktet Digjitale dhe Abonimet</h2>
              <p>Për produktet digjitale (si templejtat) ose planet e abonimit (Launch, Growth, Enterprise), kërkesat për rimbursim duhet të bëhen brenda 7 ditëve nga blerja origjinale, me kusht që asnjë material të mos jetë shkarkuar ose përdorur në masë të madhe.</p>

              <h2>4. Procesi i Rimbursimit</h2>
              <p>Të gjitha kërkesat për rimbursim duhet të dërgohen me shkrim në vizionidigjital@gmail.com. Ju lutemi përfshini numrin e porosisë dhe arsyen e detajuar të kërkesës suaj. Rimbursimet do të kreditohen përsëri në metodën origjinale të pagesës brenda 10-15 ditëve pune pas miratimit.</p>

              <h2>5. Kostot e Palëve të Treta</h2>
              <p>Ju lutemi vini re se kostot e palëve të treta (si emrat e domenit, tarifave të transaksionit të Stripe, ose licencat e softuerit) nuk janë të rimbursueshme.</p>
            </div>
          `,
        },
      },
      payment: {
        title: "Pagesa",
        instruction: "Skanoni kodin QR ose ndiqni hapat për pagesë manuale.",
        stripeTitle: "Stripe Checkout",
        stripeDesc:
          "Klikoni më poshtë për të vazhduar me siguri në Stripe Checkout. Mbështeten Visa, Mastercard dhe opsione të tjera kryesore.",
        payWithCard: "Paguaj me Kartë",
        connecting: "Duke u lidhur...",
        oneForTitle: "OneFor Apps",
        cta1: "Hap OneFor",
        cta2: "Dërgo Screenshot",
        footer: "Na kontaktoni nëse keni probleme me pagesën.",
        disclaimer: "* Siguria juaj është prioriteti ynë.",
        securedBy: "E siguruar nga Stripe",
        upgradeBadge: "PROJEKT UPGRADE / SHTESË",
        upgradeTitle: "Tarifë për Përmirësim të Projektit",
        upgradeDescription:
          "Keni nevojë për faza shtesë, integrime të veçanta ose rritje të kapaciteteve në projektin tuaj? Këtu mund të bëni pagesën për çfarëdo shume të rënë dakord për të vazhduar me përmirësimin e projektit tuaj.",
        upgradePriceLabel: "Vlera e Pagesës",
        upgradePrice: "Sipas dëshirës (Custom)",
        upgradeCta: "Paguaj Tani",
        upgradeBullet1: "Shumë e Vetme",
        upgradeBullet2: "Pagesë e Ndryshueshme",
        upgradeBullet3: "Përpunim i Shpejtë",
      },
      portfolio: {
        title: "Portofoli Ynë",
        subtitle: "Punë që flasin vetë",
        viewAll: "Shiko të gjitha",
      },
      footer: {
        desc: "Ne ndërtojmë zgjidhje digjitale që fuqizojnë bizneset në mbarë botën.",
        address: "Mitrovica, Suhodoll, Kosovo",
        phone: "+383 49 558 803",
        newsletter: "Newsletter",
        newsSub: "Abonohuni për njoftimet e fundit.",
        emailPlaceholder: "Email juaj",
        rights: "© 2026 Vizioni Digjital. Të gjitha të drejtat e rezervuara.",
        followUs: "Na ndiqni në rrjetet sociale:",
      },
    },
  },
  en: {
    translation: {
      nav: {
        services: "Services",
        pricing: "Pricing",
        work: "How We Work",
        about: "About Us",
        contact: "Contact",
        start: "Start Project",
        tracker: "Templates",
        admin: "Admin",
      },
      hero: {
        badge: "THE FUTURE IS HERE",
        title: "We Build Websites & Digital Systems That Get You Clients",
        sub: "Premium web design, SEO, and custom software development for modern brands",
        cta1: "Get a Free Strategy Call",
        cta2: "See Our Work",
        cta1_start: "Start a Project",
        cta2_work: "View Our Work",
        trustLine: "✓ Free consultation ✓ No contracts ✓ Results guaranteed",
      },
      socialProof: {
        trustedBy: "Trusted by:",
        stats:
          "25+ Projects Delivered | 1 Year Experience | 100% Client Satisfaction",
      },
      leadMagnet: {
        title: "🎁 Free Website Audit For You",
        desc: "We'll review your site and tell you exactly what's costing you clients. No charge.",
        cta: "Claim Your Free Audit",
      },
      about: {
        title: "About Us",
        myStory: "The Story of Vizioni Digjital",
        story:
          "Vizioni Digjital started with a simple belief: high-quality digital tools should be accessible to everyone, not just large corporations. As a dedicated partner, we provide expert-level web development and AI automation that helps organizations thrive.",
        heroText:
          "We don't just build websites. We craft digital experiences, meticulously engineered to elevate your brand and drive sustainable growth.",
        myMission: "Our Mission",
        mission:
          "To empower businesses by building reliable, scalable, and modern digital foundations that actually work.",
        videoTitle: "Intro Video",
        teamTitle: "Our Team",
        whyChooseUs: {
          title: "We Are Vizioni Digjital",
          desc: "A team of creatives, designers and developers passionate about building digital products that make a difference.",
          items: [
            "We build long term partnerships",
            "We deliver quality and results",
            "We focus on growth",
            "We are always improving",
          ],
          cta: "About Us",
        },
        experience: {
          years: "+2",
          desc: "Year of Experience",
        },
      },
      work: {
        title: "How We Work",
        subtitle:
          "From idea to reality. Discover our transparent development process and explore the quality standards we offer.",
        process: {
          title: "Our 4-Step Development Process",
          steps: [
            {
              title: "Discovery",
              desc: "Understanding your specific business needs and goals.",
            },
            {
              title: "Design",
              desc: "Crafting the user experience and visual interface.",
            },
            {
              title: "Development",
              desc: "Building robust, secure, and fast digital solutions.",
            },
            {
              title: "Launch & Support",
              desc: "Going live and ensuring continued performance.",
            },
          ],
        },
        concept: {
          title: "Demo Templates & Live Previews",
          subtitle:
            "Explore our pre-built, production-ready interactive templates. Use them as a powerful foundation to launch your web apps or custom solutions in record time.",
          items: [
            {
              title: "SaaS Executive Dashboard",
              desc: "A complex, real-time analytics UI built with high-performance React charts and responsive stats grids.",
            },
            {
              title: "Conversational LLM & AI Assistant",
              desc: "A fully responsive chat module ready for AI integrations, with optimized prompt streams.",
            },
            {
              title: "Premium E-Commerce Outlet",
              desc: "A fully loaded retail and e-commerce layout focusing on speed, search conversion, and seamless checkouts.",
            },
          ],
          disclaimer: "Live Demo Template",
          exploreTemplates: "Explore Our Templates →",
          processBadge: "Templates & Demos",
          featured: "Featured",
        },
        cta: {
          title: "Your First Project?",
          text: "As I am currently building my client base, I offer extra attention and discounted rates for my first few clients. Let's build something great together.",
          button: "Get Expert Attention",
        },
        portfolio: {
          title: "Our Portfolio",
          subtitle: "Work that speaks for itself",
          viewAll: "View All",
        },
      },
      contact: {
        title: "Ready to Grow? Let's Talk.",
        desc: "We respond within 24 hours.",
        form: {
          name: "Name",
          email: "Email",
          message: "Tell us about your project",
          namePlaceholder: "Your full name...",
          emailPlaceholder: "email@example.com",
          messagePlaceholder: "Describe your project in a few words...",
          submit: "Send Message",
          success: "Message Sent!",
          successDesc:
            "Thank you for reaching out. We will get back to you as soon as possible.",
          sendAnother: "Send another message",
        },
        whatsapp: "Chat on WhatsApp",
        location: "Design & Engineering Studio",
      },
      servicesPage: {
        badge: "Engineering The Future",
        title: "Digital Excellence<br /> Delivered.",
        subtitle:
          "We bring your ideas to reality with cutting-edge technology, immersive design, and battle-tested engineering.",
        ctaTitle: "Ready to transform your digital presence?",
        ctaViewWork: "View Our Work",
        ctaStart: "Start A Project",
        items: [
          {
            title: "UI/UX & Web Design",
            desc: "Custom, stunning, and highly engaging digital interfaces. We don't just build websites; we craft immersive brand experiences designed to convert visitors into loyal clients.",
            tags: [
              "Figma Prototyping",
              "Brand Identity",
              "Interactive Design",
              "Responsive Layouts",
            ],
            features: [
              "Pixel-Perfect Visual Design",
              "Mobile-First Architecture",
              "Custom Animations & 3D Elements",
              "High-Conversion Landing Pages",
            ],
          },
          {
            title: "Custom Web & App Development",
            desc: "Robust, scalable, and lightning-fast web applications. Engineered with modern tech stacks to handle complex logic, heavy traffic, and seamless integrations.",
            tags: [
              "React & Next.js",
              "Tailwind CSS",
              "TypeScript",
              "Node.js (Backend)",
            ],
            features: [
              "Full-Stack Web Applications",
              "SaaS Platform Development",
              "Progressive Web Apps (PWA)",
              "Secure Database Architecture",
            ],
          },
          {
            title: "AI Integration & Automation",
            desc: "Supercharge your business with Artificial Intelligence. We build custom LLM workflows, conversational assistants, and automated pipelines to save you hundreds of hours.",
            tags: [
              "OpenAI / Gemini integration",
              "Workflow Bots",
              "Automated Pipelines",
              "LangChain",
            ],
            features: [
              "Intelligent Chatbots & Assistants",
              "Automated Data Extraction",
              "AI-Powered Content Generation",
              "Predictive Business Analytics",
            ],
          },
          {
            title: "Enterprise Solutions & E-Commerce",
            desc: "High-performance online stores and business management systems. Tailored for maximum scalability, secure transactions, and zero-downtime reliability.",
            tags: [
              "Shopify / Custom E-Comm",
              "Stripe Integrations",
              "Inventory Systems",
              "Performance SEO",
            ],
            features: [
              "Fully Custom E-Commerce Platforms",
              "Seamless Payment Gateway Setup",
              "Advanced Technical SEO Optimization",
              "Cloud Hosting & Deployment",
            ],
          },
        ],
      },
      usecases: {
        title: "Industry Solutions",
        sub: "We solve industry-specific digital challenges.",
        items: [
          {
            title: "Restaurant & Cafe",
            desc: "Digital menus, booking systems, and modern web presence.",
          },
          {
            title: "E-Commerce",
            desc: "Fast online stores that convert visitors into customers.",
          },
          {
            title: "Business & Portfolio",
            desc: "Professional presentation of your services and work.",
          },
          {
            title: "SaaS & Tech",
            desc: "Custom software solutions for complex business needs.",
          },
        ],
      },
      process: {
        title: "How It Works",
        sub: "A simple, transparent process to get you results.",
        steps: [
          {
            title: "We Talk",
            desc: "Free 30-min call to understand your goals.",
          },
          {
            title: "We Build",
            desc: "Our team designs and develops your solution.",
          },
          {
            title: "You Grow",
            desc: "Launch, optimize, and get real results.",
          },
        ],
      },
      pricing: {
        title: "Our Plans",
        sub: "Choose the plan that fits your digital growth.",
        launch: "Launch",
        launchDesc: "Ideal for initial presence and new businesses.",
        growth: "Growth",
        growthDesc: "Perfect for businesses looking for growth and engagement.",
        enterprise: "Enterprise",
        enterpriseDesc: "Complex and automated solutions for corporations.",
        features: {
          onePage: "One Page Website",
          maps: "Google Maps Integration",
          basicSeo: "Basic SEO",
          multiPage: "Up to 5 Pages",
          whatsapp: "WhatsApp Button",
          advSeo: "Advanced SEO",
          ecommerce: "Online Store (E-commerce)",
          mobileApp: "Mobile Application",
          aiChatbot: "Personal AI Chatbot",
        },
        maint: "Maintenance plans starting at €49/mo",
        cta: "Start Your Website",
        refund: "* Full refund if you are not satisfied with the final result.",
        pricingPage: {
          title: "Our Plans",
          subtitle: "Choose the plan that fits your business.",
          demoCta: "Free Demo",
          mostPopular: "Most Popular",
          footerLines: [
            "Domain is purchased by you on Porkbun (or we buy it for you at an additional cost of 15€/year).",
            "Prices include the initial build. Major structural changes after delivery are not included in monthly maintenance but can be provided at a special price.",
          ],
          launchquote:
            "“The perfect start for a business that wants its first online presence.”",
          launchheader: "What it really includes",
          growthquote:
            "“For businesses that want more pages and direct interaction with clients.”",
          growthheader: "What it really includes",
          enterprisequote:
            "“Complete solution for businesses that want automation and online sales.”",
          enterpriseheader: "What it really includes",
          launchfeat1Title: "One Page Website",
          launchfeat1Desc:
            "Modern design, personalized with your colors and logo. Adapted for mobile and tablet. Contains: header, about us, services, gallery, and contact — everything on a single page.",
          launchfeat2Title: "Google Maps Integration",
          launchfeat2Desc:
            "Exact location map placed on the page. Clients find their way with a click.",
          launchfeat3Title: "Basic SEO",
          launchfeat3Desc:
            "Title and description optimized for Google, main keywords, link to Google My Business, and page registered in Google Search Console.",
          launchfeat4Title: "Contact Form",
          launchfeat4Desc:
            "A simple form that sends messages directly to your email. Unlimited.",
          launchfeat5Title: "Assistance with domain linking",
          launchfeat5Desc:
            "We help you buy and link your domain (e.g., name.com).",
          launchfeat6Title: "Optional maintenance 49€/month",
          launchfeat6Desc:
            "Includes: secure hosting, technical updates, daily backup, and up to 2 small changes per month (text, photos, schedule).",
          growthfeat1Title: "Up to 5 custom pages",
          growthfeat1Desc:
            "For example: Home, About Us, Services, Gallery, Contact. Each page optimized and unique.",
          growthfeat2Title: "WhatsApp Button",
          growthfeat2Desc:
            "A floating button that allows clients to write to you on WhatsApp with one click, without saving the number. Significantly increases requests.",
          growthfeat3Title: "Advanced SEO",
          growthfeat3Desc:
            "Local keyword research, optimization of each page, unique titles, meta descriptions, friendly URL structure, and integration with Google Analytics.",
          growthfeat4Title: "Custom design with 2 review rounds",
          growthfeat4Desc:
            "You send your ideas, we turn them into design, and you have two rounds of changes until you are 100% satisfied.",
          growthfeat5Title: "Social Media Integration",
          growthfeat5Desc:
            "Direct link to your Instagram, Facebook, and TikTok. Icons on the page and option to display the Instagram feed.",
          growthfeat6Title: "Speed and mobile optimization",
          growthfeat6Desc:
            "The page loads in less than 2 seconds and looks perfect on any screen.",
          growthfeat7Title: "Optional maintenance 49€/month",
          growthfeat7Desc:
            "Includes: hosting, backup, security updates, and up to 4 small changes per month (e.g., price changes, new photos).",
          enterfeat1Title: "Online Store (E-commerce)",
          enterfeat1Desc:
            "Add up to 50 products, manage stock, accept online orders. Integration with local payments (e.g., Paysera, bank) upon agreement. No commission on sales.",
          enterfeat2Title: "Mobile App (PWA)",
          enterfeat2Desc:
            "A version of the site that installs on the phone like an app, without needing to download from the App Store. Works offline and sends notifications.",
          enterfeat3Title: "Personal AI Chatbot",
          enterfeat3Desc:
            "Virtual assistant that answers clients' frequently asked questions 24/7, takes orders and automatic reservations.",
          enterfeat4Title: "Booking System",
          enterfeat4Desc:
            "Complete booking system. Clients choose date, time, and service; you manage everything from your admin panel.",
          enterfeat5Title: "Custom Admin Panel",
          enterfeat5Desc:
            "Complete control over content, products, orders, and clients without needing coding.",
          enterfeat6Title: "Premium SEO & monthly reporting",
          enterfeat6Desc:
            "Deep technical optimization, monthly report with visitor graphics, and suggestions for improvement.",
          enterfeat7Title: "1-hour training for your staff",
          enterfeat7Desc:
            "We teach you how to use the panel and add content yourself.",
          enterfeat8Title: "Optional maintenance 49€/month",
          enterfeat8Desc:
            "Includes: premium hosting, daily backup, 24/7 monitoring, regular updates, and up to 6 small changes per month.",
        },
      },
      faqs: {
        title: "Frequently Asked Questions",
        sub: "Everything you need to know to get started.",
        items: [
          {
            q: "How long does it take to build a website?",
            a: "For base projects, average time is 7-10 days. Complex ones can take 3-6 weeks.",
          },
          {
            q: "Do you offer maintenance?",
            a: "Yes, we offer monthly maintenance plans to keep your site updated and secure.",
          },
          {
            q: "Can I change content myself?",
            a: "Absolutely. Every site comes with a simple admin panel for easy updates.",
          },
          {
            q: "Are your websites SEO optimized?",
            a: "Yes, SEO is an integral part of every project we build.",
          },
          {
            q: "What is the refund policy?",
            a: "At Vizioni Digjital, we offer full refunds if we fail to deliver according to agreement.",
          },
        ],
      },
      testimonials: {
        title: "What our clients say",
        sub: "Your success is our best proof.",
        viewAll: "View All Testimonials",
        items: [
          {
            name: "Agim Krasniqi",
            role: "CEO, TechKos",
            text: "Vizioni Digjital understood exactly what we needed. Our new website doubled our incoming leads in just one month. Highly dedicated team!",
          },
          {
            name: "Besnik Hoxha",
            role: "Director, AutoKosova",
            text: "The system they built is incredibly fast and easy to use. It saves us hours of work every day and our sales have increased significantly.",
          },
          {
            name: "Elena K.",
            role: "Founder, Boutique",
            text: "Beautiful design and excellent SEO optimization. New clients are finding us easier than ever through Google searches.",
          },
        ],
      },
      chat: {
        title: "Chat with Us",
        name: "Name",
        surname: "Surname",
        username: "Username",
        email: "Email",
        msg: "How can we help?",
        sentAs: "Sent as:",
        screenshotLabel: "Optional: Add Screenshot",
        uploadScreenshot: "Upload Photo",
        imageSelected: "Image selected ✅",
        send: "Send",
        sending: "Sending...",
        success: "Message sent! 🚀",
        placeholder: "Ask e.g.: 'How much is the Growth plan?'",
        aiTab: "AI Support",
        contactTab: "Contact Us",
        badgeAi: "Digital Assistant",
      },
      tracker: {
        title: "Development",
        titleAccent: "Trends.",
        sub: "Discover our top-rated websites and modern engineering projects.",
        viewAll: "View All",
        filters: {
          all: "All",
          web: "Web",
          mobile: "Mobile",
          ai: "AI",
          restaurant: "Restaurant & Cafe",
          ecommerce: "E-Commerce",
          business: "Business",
          portfolio: "Portfolio",
          templates: "Templates",
          branding: "Branding",
          design: "Design",
        },
        sort: { popular: "Most Popular", newest: "Newest", seo: "SEO Rating" },
        searchPlaceholder: "Search projects or templates...",
        noProjects: "No projects found.",
        description: "Description",
        reviews: "Reviews",
        addReview: "Add Review",
        noReviews: "No reviews yet. Be the first!",
        rating: "Rating",
        commentPlaceholder: "Write your thoughts...",
        send: "Send",
        cancel: "Cancel",
        loginToLike: "Please login to like.",
        loginToReview: "Please login to review.",
        iframeWarning: {
          title: "Problem with the view?",
          text: "If the page above doesn't load, security platforms may block the integration (iFrame).",
          link: "Click here to view it directly.",
        },
        livePreview: {
          title: "Live Preview",
          note: "The website design might change inside the frame.",
        },
      },
      insights: {
        title: "Our Blog",
        subtitle: "Insights & Articles That Inspire",
        viewAll: "View All",
        readOtherArticles: "Read other articles",
        articles: [
          {
            title: "10 Web Design Trends To Watch In 2024",
            date: "May 10, 2024",
            tag: "WEB DESIGN",
          },
          {
            title: "How To Grow Your Brand On Social Media",
            date: "May 8, 2024",
            tag: "MARKETING",
          },
          {
            title: "SEO Best Practices For Higher Rankings",
            date: "May 3, 2024",
            tag: "SEO",
          },
        ],
      },
      profile: {
        title: "My Profile",
        logout: "Logout",
        myProjects: "My Projects",
        publishProject: "Publish Project",
        noProjects: "You haven't published any projects yet.",
        deleteConfirm: "Are you sure you want to delete this project?",
        yesDelete: "Yes, Delete",
        cancel: "Cancel",
        subDetails: "Subscription Details",
        status: "Status",
        active: "Active",
        inactive: "Inactive",
        expires: "Expires on",
        noExpiry: "No expiry",
        wantMore: "Want more?",
        upgradeSub:
          "Upgrade your plan to get higher SEO rating and priority support.",
        viewPlans: "View Plans",
      },
      publish: {
        title: "Publish",
        titleAccent: "Your Project.",
        projectTitle: "Project Title",
        url: "Website URL",
        category: "Category",
        description: "Short Description",
        submit: "Publish Now",
        submitting: "Publishing...",
        placeholderTitle: "e.g. My Online Store",
        placeholderUrl: "https://your-website.com",
      },
      subscription: {
        notification: "Subscription Notification",
        expiresTomorrow:
          "Your subscription expires tomorrow! Please renew to continue service.",
        expiresInDays: "Your subscription expires in {{days}} days.",
        expired:
          "Your subscription has expired. Please contact staff for renewal.",
        renewNow: "Renew Now",
      },
      common: {
        login: "Login",
        loginToView: "Please login to view this page.",
        loading: "Loading...",
        error: "Error",
        success: "Success",
        anonymous: "Anonymous",
      },
      seo: {
        defaultTitle:
          "Vizioni Digjital | Web Design Kosovo & Custom Software Development Agency",
        homeDesc:
          "Vizioni Digjital is a premier web design and custom software development agency in Kosovo. We build professional, fully SEO-optimized websites, secure e-commerce platforms, and advanced custom software solutions.",
        homeKeywords:
          "web design kosovo, custom software development kosovo, bespoke web application development, professional seo agency pristina, custom web systems, e-commerce store development, vizioni digjital",
        aboutTitle: "About Us",
        aboutDesc:
          "Learn the story of Vizioni Digjital and our mission as a technology partner.",
        workTitle: "How We Work",
        workDesc:
          "Discover our transparent 4-step development process and explore our creative projects.",
        contactTitle: "Contact",
        contactDesc:
          "Get in touch with us for professional web development and custom AI solutions.",
        servicesTitle: "Services",
        servicesDesc:
          "Professional web design, mobile apps, and AI automation tailored for your business.",
        pricingTitle: "Plans & Pricing",
        pricingDesc:
          "Choose the ideal plan for your business. From basic packages to advanced Enterprise solutions.",
        templatesTitle: "Our Templates & Systems",
        templatesDesc:
          "Browse our library of premium templates and ready-to-use systems for businesses.",
        blogTitle: "Blog & Insights",
        blogDesc:
          "Latest technology news, SEO tips, and strategies for digital growth.",
        privacyTitle: "Privacy Policy",
        termsTitle: "Terms of Use",
        refundTitle: "Refund Policy",
        legalDesc:
          "Read the {{title}} of Vizioni Digjital. We are committed to transparency and security.",
      },
      admin: {
        title: "Admin",
        titleAccent: "Dashboard.",
        logout: "Log Out",
        accessDenied: "Access Denied",
        accessDeniedSub: "Only admins can see this.",
        stats: {
          totalMessages: "Messages",
          unread: "Unread",
          liveProjects: "Projects",
          paymentConfirmations: "Payments",
        },
        tabs: {
          messages: "Messages",
          projects: "Projects",
          users: "Users",
        },
        messages: {
          replyEmail: "Reply Email",
          replySubject: "Reply from Vizioni Digjital",
          replyBody: "Hello {{name}},...",
          confirmPayment: "Confirm Payment",
          paymentSubject: "Payment Confirmation - Vizioni Digjital",
          paymentText:
            "Hello {{name}}, your payment has been successfully confirmed.",
          markAsRead: "Mark as read",
          markAsUnread: "Mark as unread",
          delete: "Delete",
          confirmDelete: "Confirm Delete",
          cancel: "Cancel",
          screenshotConfirmation: "Screenshot Confirmation",
        },
        addProject: {
          title: "Add Project",
          submit: "Save",
        },
        users: {
          plan: "Plan",
          expiry: "Expiry",
          status: "Status",
          save: "Save",
        },
      },
      legal: {
        privacy: {
          title: "Privacy Policy",
          content: `
            <div class="prose prose-invert max-w-none">
              <h2>1. Introduction</h2>
              <p>Welcome to Vizioni Digjital. We are committed to protecting your privacy and personal data. This privacy policy informs you about how we look after your personal data when you visit our website and tells you about your privacy rights.</p>

              <h2>2. Data We Collect</h2>
              <p>We may collect, use, store and transfer different kinds of personal data about you, including:</p>
              <ul>
                <li><strong>Identity Data:</strong> First name, last name, username or similar identifier.</li>
                <li><strong>Contact Data:</strong> Billing address, email address and telephone numbers.</li>
                <li><strong>Technical Data:</strong> Internet protocol (IP) address, your login data, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform, and other technology on the devices you use to access this website.</li>
                <li><strong>Usage Data:</strong> Information about how you use our website, products and services.</li>
              </ul>

              <h2>3. How We Use Your Data</h2>
              <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
              <ul>
                <li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>
                <li>Where it is necessary for our legitimate interests and your interests and fundamental rights do not override those interests.</li>
                <li>Where we need to comply with a legal or regulatory obligation.</li>
              </ul>

              <h2>4. Data Security</h2>
              <p>We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed. In addition, we limit access to your personal data to those employees, agents and other third parties who have a business need to know.</p>

              <h2>5. Payments and Stripe Privacy</h2>
              <p>We use <strong>Stripe</strong> for payment processing. We do not store or retain your credit or debit card details on our servers. All payment information is securely processed and stored by Stripe. By using our services, you also agree to Stripe's privacy policy, which you can find at <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">stripe.com/privacy</a>.</p>

              <h2>6. Data Retention</h2>
              <p>We will only retain your personal data for as long as necessary to fulfill the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements.</p>

              <h2>7. Cookies and Google AdSense</h2>
              <p>Our site uses "cookies" to enhance user experience. We may use Google AdSense to display ads. Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie enables it to serve ads to our users based on their visit to our site and other sites on the Internet.</p>

              <h2>8. Your Rights</h2>
              <p>Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to request access, correction, erasure, restriction, transfer, to object to processing.</p>
            </div>
          `,
        },
        terms: {
          title: "Terms of Use",
          content: `
            <div class="prose prose-invert max-w-none">
              <h2>1. Acceptance of Terms</h2>
              <p>By accessing and using the Vizioni Digjital website, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by these terms, please do not use our service.</p>

              <h2>2. Description of Service</h2>
              <p>Vizioni Digjital provides web development, mobile applications, graphic design, and Artificial Intelligence solutions. We reserve the right to modify or discontinue the service with or without notice.</p>

              <h2>3. User Responsibilities</h2>
              <p>As a user, you are responsible for maintaining the confidentiality of your account and password. You agree to notify Vizioni Digjital immediately of any unauthorized use of your account.</p>

              <h2>4. Intellectual Property</h2>
              <p>All content included on this site, such as text, graphics, logos, button icons, images, and software, is the property of Vizioni Digjital or its content suppliers and protected by international copyright laws.</p>

              <h2>5. Limitation of Liability</h2>
              <p>Vizioni Digjital shall not be liable for any direct, indirect, incidental, consequential or exemplary damages resulting from the use or the inability to use our service.</p>

              <h2>6. Changes to Terms</h2>
              <p>We reserve the right to change these conditions at any time. Continued use of the site after any such changes shall constitute your consent to such changes.</p>

              <h2>7. Governing Law</h2>
              <p>These terms shall be governed and construed in accordance with the laws of the Republic of Albania and Kosovo, without regard to its conflict of law provisions.</p>
            </div>
          `,
        },
        refund: {
          title: "Refund Policy",
          content: `
            <div class="prose prose-invert max-w-none">
              <h2>1. General Policy</h2>
              <p>At Vizioni Digjital, we aim to provide highest quality services. However, we understand there might be circumstances where a refund is needed.</p>

              <h2>2. Development Services (Web & Apps)</h2>
              <p>Due to the nature of custom development services, refunds are processed as follows:</p>
              <ul>
                <li><strong>Before work starts:</strong> 100% full refund.</li>
                <li><strong>During design phase:</strong> Up to 50% refund of the amount paid.</li>
                <li><strong>After code development begins:</strong> No refunds are provided due to the committed labor hours.</li>
              </ul>

              <h2>3. Digital Products and Subscriptions</h2>
              <p>For digital products (like templates) or subscription plans (Launch, Growth, Enterprise), refund requests must be made within 7 days of the original purchase, provided no material has been downloaded or extensively used.</p>

              <h2>4. Refund Process</h2>
              <p>All refund requests must be sent in writing to vizionidigjital@gmail.com. Please include your order number and detailed reason for your request. Refunds will be credited back to the original payment method within 10-15 business days after approval.</p>

              <h2>5. Third-Party Costs</h2>
              <p>Please note that any third-party costs (such as domain names, Stripe transaction fees, or software licenses) are non-refundable.</p>
            </div>
          `,
        },
      },
      payment: {
        title: "Payment",
        instruction: "Scan QR or follow steps for manual payment.",
        stripeTitle: "Stripe Checkout",
        stripeDesc:
          "Click below to securely proceed to Stripe Checkout. Visa, Mastercard, and other major options are supported.",
        payWithCard: "Pay with Card",
        connecting: "Connecting...",
        oneForTitle: "OneFor Apps",
        cta1: "Open OneFor",
        cta2: "Send Screenshot",
        footer: "Contact us for help.",
        disclaimer: "* Secure payments.",
        securedBy: "Secured by Stripe",
        upgradeBadge: "PROJECT UPGRADE / ADD-ON",
        upgradeTitle: "Project Upgrade Fee",
        upgradeDescription:
          "Need additional phases, custom integrations, or increased capacities on your project? Here you can pay any agreed-upon custom amount to proceed with upgrading your project.",
        upgradePriceLabel: "Payment Amount",
        upgradePrice: "Custom (Pay what you want)",
        upgradeCta: "Pay Now",
        upgradeBullet1: "One-Time Payment",
        upgradeBullet2: "Flexible Amount",
        upgradeBullet3: "Instant Processing",
      },
      portfolio: {
        title: "Our Portfolio",
        subtitle: "Work that speaks for itself",
        viewAll: "View All",
      },
      footer: {
        desc: "We build digital solutions that empower businesses worldwide.",
        address: "Mitrovica, Suhodoll, Kosovo",
        phone: "+383 49 558 803",
        newsletter: "Newsletter",
        newsSub: "Subscribe for updates.",
        emailPlaceholder: "Your Email",
        rights: "© 2026 Vizioni Digjital. All rights reserved.",
        followUs: "Follow us on social media:",
      },
    },
  },
  de: {
    translation: {
      nav: {
        services: "Dienstleistungen",
        pricing: "Preise",
        work: "Wie wir arbeiten",
        about: "Über uns",
        contact: "Kontakt",
        start: "Start",
        tracker: "Vorlagen",
        admin: "Admin",
      },
      hero: {
        badge: "DIE ZUKUNFT IST HIER",
        title:
          "Wir bauen Websites & digitale Systeme, die Ihnen Kunden bringen",
        sub: "Premium-Webdesign, SEO und maßgeschneiderte Softwareentwicklung für moderne Marken",
        cta1: "Kostenloses Beratungsgespräch",
        cta2: "Unsere Arbeit",
        cta1_start: "Projekt starten",
        cta2_work: "Unsere Arbeit ansehen",
        trustLine:
          "✓ Kostenlose Beratung ✓ Keine Verträge ✓ Garantierte Ergebnisse",
      },
      socialProof: {
        trustedBy: "Vertraut von:",
        stats:
          "25+ Projekte Ausgeliefert | 1 Jahr Erfahrung | 100% Kundenzufriedenheit",
      },
      leadMagnet: {
        title: "🎁 Kostenloses Website-Audit für Sie",
        desc: "Wir überprüfen Ihre Website und sagen Ihnen genau, was Sie Kunden kostet. Kostenlos.",
        cta: "Holen Sie sich Ihr Audit",
      },
      about: {
        title: "Über uns",
        myStory: "Die Geschichte von Vizioni Digjital",
        story:
          "Vizioni Digjital entstand aus der einfachen Überzeugung heraus, dass hochwertige digitale Werkzeuge für jeden zugänglich sein sollten, nicht nur für große Konzerne. Als engagierter Partner bieten wir Webentwicklung auf Expertenniveau und KI-Automatisierung an, die Unternehmen zum Erfolg verhelfen.",
        heroText:
          "Wir bauen nicht nur Websites. Wir erschaffen digitale Erlebnisse, die sorgfältig darauf ausgelegt sind, Ihre Marke zu stärken und nachhaltiges Wachstum zu fördern.",
        myMission: "Unsere Mission",
        mission:
          "Unternehmen zu stärken, indem wir zuverlässige, skalierbare und moderne digitale Fundamente schaffen, die wirklich funktionieren.",
        videoTitle: "Einführungsvideo",
        teamTitle: "Unser Team",
        whyChooseUs: {
          title: "Wir sind Vizioni Digjital",
          desc: "Ein Team aus Kreativen, Designern und Entwicklern, das leidenschaftlich daran arbeitet, digitale Produkte zu schaffen, die einen Unterschied machen.",
          items: [
            "Wir bauen langfristige Partnerschaften auf",
            "Wir liefern Qualität und Ergebnisse",
            "Wir konzentrieren uns auf Wachstum",
            "Wir verbessern uns ständig",
          ],
          cta: "Über uns",
        },
        experience: {
          years: "+2",
          desc: "Jahr Erfahrung",
        },
      },
      work: {
        title: "Wie wir arbeiten",
        subtitle:
          "Von der Idee zur Realität. Entdecken Sie unseren transparenten Entwicklungsprozess und erkunden Sie den Qualitätsstandard, den wir bieten.",
        process: {
          title: "Unser 4-stufiger Entwicklungsprozess",
          steps: [
            {
              title: "Analyse & Discovery",
              desc: "Verständnis Ihrer spezifischen Geschäftsanforderungen und Ziele.",
            },
            {
              title: "Design",
              desc: "Entwicklung der Benutzererfahrung und der visuellen Oberfläche.",
            },
            {
              title: "Entwicklung",
              desc: "Erstellung robuster, sicherer und schneller digitaler Lösungen.",
            },
            {
              title: "Launch & Support",
              desc: "Livegang und Sicherstellung der kontinuierlichen Leistung.",
            },
          ],
        },
        concept: {
          title: "Demo-Templates & Live-Vorschauen",
          subtitle:
            "Entdecken Sie unsere einsatzbereiten, interaktiven Vorlagen. Nutzen Sie diese als stabiles Fundament, um Ihre Web-Apps oder maßgeschneiderten Lösungen in Rekordzeit zu starten.",
          items: [
            {
              title: "SaaS Executive Dashboard",
              desc: "Ein komplexes Dashboard für Echtzeit-Analysen mit hochperformanten React-Charts und reaktionsschnellen Rastern.",
            },
            {
              title: "Interaktiver KI-Chat-Assistent",
              desc: "Ein vollständig responsives Chat-Modul, optimiert für modernste KI-Modelle, Streaming und Automatisierungen.",
            },
            {
              title: "Premium E-Commerce Store",
              desc: "Ein modernes Online-Shopping-Template mit Fokus auf Geschwindigkeit, Filterfunktionen und reibungslose Checkouts.",
            },
          ],
          disclaimer: "Live Demo Template",
          exploreTemplates: "Vorlage entdecken →",
          processBadge: "Templates & Demos",
          featured: "Hervorgehoben",
        },
        cta: {
          title: "Ihr erstes Projekt?",
          text: "Da ich derzeit meinen Kundenstamm aufbaue, biete ich meinen ersten Kunden besondere Aufmerksamkeit und vergünstigte Konditionen an. Lassen Sie uns gemeinsam etwas Großartiges schaffen.",
          button: "Experten-Beratung anfordern",
        },
        portfolio: {
          title: "Unser Portfolio",
          subtitle: "Arbeiten, die für sich sprechen",
          viewAll: "Alle ansehen",
        },
      },
      contact: {
        title: "Bereit zum Wachsen? Lassen Sie uns reden.",
        desc: "Wir antworten innerhalb von 24 Stunden.",
        form: {
          name: "Name",
          email: "Email",
          message: "Erzählen Sie uns von Ihrem Projekt",
          namePlaceholder: "Ihr vollständiger Name...",
          emailPlaceholder: "email@beispiel.de",
          messagePlaceholder:
            "Beschreiben Sie Ihr Projekt in ein paar Worten...",
          submit: "Nachricht senden",
          success: "Nachricht gesendet!",
          successDesc:
            "Vielen Dank für Ihre Nachricht. Wir werden uns so schnell wie möglich bei Ihnen melden.",
          sendAnother: "Weitere Nachricht senden",
        },
        whatsapp: "WhatsApp Chat",
        location: "Design & Engineering Studio",
      },
      servicesPage: {
        badge: "Die Zukunft entwickeln",
        title: "Digitale Exzellenz<br /> Geliefert.",
        subtitle:
          "Wir verwirklichen Ihre Ideen mit modernster Technologie, immersivem Design und praxiserprobter Technik.",
        ctaTitle: "Bereit, Ihre digitale Präsenz zu transformieren?",
        ctaViewWork: "Unsere Arbeiten ansehen",
        ctaStart: "Ein Projekt starten",
        items: [
          {
            title: "UI/UX & Webdesign",
            desc: "Beeindruckende, maßgeschneiderte digitale Oberflächen. Wir bauen nicht nur Websites; wir kreieren fesselnde Markenerlebnisse, die Besucher in treue Kunden verwandeln.",
            tags: [
              "Figma Prototyping",
              "Markenidentität",
              "Interaktives Design",
              "Responsive Layouts",
            ],
            features: [
              "Pixelgenaues Visual Design",
              "Mobile-First-Architektur",
              "Benutzerdefinierte Animationen & 3D",
              "Konversionsstarke Landingpages",
            ],
          },
          {
            title: "Web- & App-Entwicklung",
            desc: "Robuste, skalierbare und blitzschnelle Webanwendungen. Entwickelt mit modernen Tech-Stacks, um komplexe Logik und hohen Traffic nahtlos zu verarbeiten.",
            tags: [
              "React & Next.js",
              "Tailwind CSS",
              "TypeScript",
              "Node.js (Backend)",
            ],
            features: [
              "Full-Stack Web-Apps",
              "SaaS-Plattform-Entwicklung",
              "Progressive Web Apps (PWA)",
              "Sichere Datenbankarchitektur",
            ],
          },
          {
            title: "KI-Integration & Automatisierung",
            desc: "Bringen Sie Ihr Unternehmen mit Künstlicher Intelligenz auf das nächste Level. Wir bauen benutzerdefinierte LLM-Workflows und Chatbots, die Hunderte von Stunden sparen.",
            tags: [
              "OpenAI / Gemini",
              "Workflow-Bots",
              "Automatisierte Pipelines",
              "LangChain",
            ],
            features: [
              "Intelligente Chatbots",
              "Automatisierte Datenextraktion",
              "KI-gestützte Content-Generierung",
              "Prädiktive Geschäftsanalytik",
            ],
          },
          {
            title: "E-Commerce & Enterprise",
            desc: "Leistungsstarke Online-Shops und Business-Management-Systeme. Entwickelt für maximale Skalierbarkeit, sichere Transaktionen und Zuverlässigkeit ohne Ausfallzeiten.",
            tags: [
              "Shopify / Custom E-Comm",
              "Stripe-Integrationen",
              "Inventarsysteme",
              "Performantes SEO",
            ],
            features: [
              "Maßgeschneiderte E-Commerce-Plattformen",
              "Nahtloses Payment Gateway Setup",
              "Erweiterte technische SEO-Optimierung",
              "Cloud-Hosting & Deployment",
            ],
          },
        ],
      },
      usecases: {
        title: "Branchenlösungen",
        sub: "Wir lösen branchenspezifische Herausforderungen.",
        items: [
          {
            title: "Gastronomie",
            desc: "Digitale Menüs, Reservierungssysteme und moderner Webauftritt.",
          },
          {
            title: "E-Commerce",
            desc: "Schnelle Online-Shops, die Besucher in Kunden verwandeln.",
          },
          {
            title: "Business & Portfolio",
            desc: "Professionelle Präsentation Ihrer Dienstleistungen.",
          },
          {
            title: "SaaS & Technik",
            desc: "Eigene Softwarelösungen für komplexe Geschäftsanforderungen.",
          },
        ],
      },
      process: {
        title: "Wie es funktioniert",
        sub: "Ein einfacher, transparenter Prozess, der Ergebnisse liefert.",
        steps: [
          {
            title: "Wir reden",
            desc: "Kostenloses 30-minütiges Gespräch zum Verständnis Ihrer Ziele.",
          },
          {
            title: "Wir bauen",
            desc: "Unser Team entwirft und entwickelt Ihre Lösung.",
          },
          {
            title: "Sie wachsen",
            desc: "Launch, Optimierung und echte Ergebnisse.",
          },
        ],
      },
      pricing: {
        title: "Unsere Pläne",
        sub: "Wählen Sie den Plan, der zu Ihrem digitalen Wachstum passt.",
        launch: "Launch",
        launchDesc: "Ideal für die erste Präsenz und neue Unternehmen.",
        growth: "Growth",
        growthDesc:
          "Perfekt für Unternehmen, die Wachstum und Engagement suchen.",
        enterprise: "Enterprise",
        enterpriseDesc: "Komplexe und automatisierte Lösungen für Konzerne.",
        features: {
          onePage: "One Page Website",
          maps: "Google Maps Integration",
          basicSeo: "Basis SEO",
          multiPage: "Bis zu 5 Seiten",
          whatsapp: "WhatsApp Button",
          advSeo: "Erweiterte SEO",
          ecommerce: "Online Shop (E-Commerce)",
          mobileApp: "Mobile Anwendung",
          aiChatbot: "Persönlicher KI-Chatbot",
        },
        maint: "Wartungspläne ab 49€ / Monat",
        cta: "Starten Sie Ihre Website",
        refund:
          "* Volle Rückerstattung, wenn Sie mit dem Ergebnis nicht zufrieden sind.",
        pricingPage: {
          title: "Unsere Pläne",
          subtitle: "Wählen Sie den Plan, der zu Ihrem Geschäft passt.",
          demoCta: "Kostenlose Demo",
          mostPopular: "Am beliebtesten",
          footerLines: [
            "Die Domain wird von Ihnen bei Porkbun gekauft (oder wir kaufen sie für Sie für 15€/Jahr zusätzlich).",
            "Die Preise beinhalten den anfänglichen Aufbau. Größere strukturelle Änderungen nach der Übergabe sind nicht in der monatlichen Wartung enthalten, können aber zu einem Sonderpreis angeboten werden.",
          ],
          launchquote:
            "“Der perfekte Start für ein Unternehmen, das seine erste Online-Präsenz aufbauen möchte.”",
          launchheader: "Was wirklich drin ist",
          growthquote:
            "“Für Unternehmen, die mehr Seiten und direkte Interaktion mit Kunden wünschen.”",
          growthheader: "Was wirklich drin ist",
          enterprisequote:
            "“Komplettlösung für Unternehmen, die Automatisierung und Online-Verkauf wünschen.”",
          enterpriseheader: "Was wirklich drin ist",
          launchfeat1Title: "One Page Website",
          launchfeat1Desc:
            "Modernes Design, personalisiert mit Ihren Farben und Ihrem Logo. Angepasst für Handy und Tablet. Enthält: Header, Über uns, Leistungen, Galerie und Kontakt — alles auf einer einzigen Seite.",
          launchfeat2Title: "Google Maps Integration",
          launchfeat2Desc:
            "Genaue Standortkarte auf der Seite. Kunden finden mit einem Klick zu Ihnen.",
          launchfeat3Title: "Basis SEO",
          launchfeat3Desc:
            "Titel und Beschreibung für Google optimiert, Haupt-Keywords, Verknüpfung mit Google My Business und bei Google Search Console registrierte Seite.",
          launchfeat4Title: "Kontaktformular",
          launchfeat4Desc:
            "Ein einfaches Formular, das Nachrichten direkt an Ihre E-Mail sendet. Unbegrenzt.",
          launchfeat5Title: "Unterstützung bei der Domain-Verknüpfung",
          launchfeat5Desc:
            "Wir helfen Ihnen, Ihre Domain zu kaufen und zu verknüpfen (z.B. name.com).",
          launchfeat6Title: "Optionale Wartung 49€/Monat",
          launchfeat6Desc:
            "Beinhaltet: sicheres Hosting, technische Updates, tägliches Backup und bis zu 2 kleine Änderungen pro Monat (Text, Fotos, Zeitplan).",
          growthfeat1Title: "Bis zu 5 benutzerdefinierte Seiten",
          growthfeat1Desc:
            "Zum Beispiel: Startseite, Über uns, Leistungen, Galerie, Kontakt. Jede Seite optimiert und einzigartig.",
          growthfeat2Title: "WhatsApp Button",
          growthfeat2Desc:
            "Ein schwebender Button, über den Kunden Ihnen mit einem Klick auf WhatsApp schreiben können, ohne die Nummer speichern zu müssen. Erhöht die Anfragen deutlich.",
          growthfeat3Title: "Erweiterte SEO",
          growthfeat3Desc:
            "Lokale Keyword-Recherche, Optimierung jeder Seite, einzigartige Titel, Meta-Beschreibungen, benutzerfreundliche URL-Struktur und Integration von Google Analytics.",
          growthfeat4Title: "Individuelles Design mit 2 Korrekturschleifen",
          growthfeat4Desc:
            "Sie senden Ihre Ideen, wir verwandeln sie in ein Design und Sie haben zwei Runden für Änderungen, bis Sie 100% zufrieden sind.",
          growthfeat5Title: "Social Media Integration",
          growthfeat5Desc:
            "Direkte Verknüpfung zu Ihrem Instagram, Facebook und TikTok. Symbole auf der Seite und Option zur Anzeige des Instagram-Feeds.",
          growthfeat6Title: "Geschwindigkeit und mobile Optimierung",
          growthfeat6Desc:
            "Die Seite lädt in weniger als 2 Sekunden und sieht auf jedem Bildschirm perfekt aus.",
          growthfeat7Title: "Optionale Wartung 49€/Monat",
          growthfeat7Desc:
            "Beinhaltet: Hosting, Backup, Sicherheitsupdates und bis zu 4 kleine Änderungen pro Monat (z.B. Preisänderungen, neue Fotos).",
          enterfeat1Title: "Online Shop (E-Commerce)",
          enterfeat1Desc:
            "Bis zu 50 Produkte hinzufügen, Lagerbestand verwalten, Online-Bestellungen annehmen. Integration lokaler Zahlungsmittel (z.B. Paysera, Bank) nach Absprache. Keine Verkaufsprovision.",
          enterfeat2Title: "Mobile App (PWA)",
          enterfeat2Desc:
            "Eine Version der Website, die sich wie eine App auf dem Telefon installieren lässt, ohne aus dem App Store heruntergeladen werden zu müssen. Funktioniert offline und sendet Benachrichtigungen.",
          enterfeat3Title: "Persönlicher KI-Chatbot",
          enterfeat3Desc:
            "Virtueller Assistent, der häufig gestellte Kundenfragen 24/7 beantwortet, Bestellungen und automatische Reservierungen annimmt.",
          enterfeat4Title: "Buchungssystem",
          enterfeat4Desc:
            "Komplettes Buchungssystem. Kunden wählen Datum, Uhrzeit und Service; Sie verwalten alles über Ihr Admin-Panel.",
          enterfeat5Title: "Benutzerdefiniertes Admin-Panel",
          enterfeat5Desc:
            "Volle Kontrolle über Inhalte, Produkte, Bestellungen und Kunden ohne Programmierkenntnisse.",
          enterfeat6Title: "Premium SEO & monatliches Reporting",
          enterfeat6Desc:
            "Tiefe technische Optimierung, monatlicher Bericht mit Besuchergrafiken und Verbesserungsvorschlägen.",
          enterfeat7Title: "1-stündiges Training für Ihr Personal",
          enterfeat7Desc:
            "Wir zeigen Ihnen, wie Sie das Panel nutzen und selbst Inhalte einfügen.",
          enterfeat8Title: "Optionale Wartung 49€/Monat",
          enterfeat8Desc:
            "Beinhaltet: Premium-Hosting, tägliches Backup, 24/7 Monitoring, regelmäßige Updates und bis zu 6 kleine Änderungen pro Monat.",
        },
      },
      faqs: {
        title: "Häufig gestellte Fragen (FAQ)",
        sub: "Alles, was Sie für den Start wissen müssen.",
        items: [
          {
            q: "Wie lange dauert die Erstellung einer Website?",
            a: "Für Basisprojekte beträgt die durchschnittliche Zeit 7-10 Tage. Komplexere Projekte können 3-6 Wochen in Anspruch nehmen.",
          },
          {
            q: "Bieten Sie Wartungsdienste nach Projektabschluss an?",
            a: "Ja, wir bieten monatliche Wartungspläne an, um sicherzustellen, dass Ihre Website immer aktuell, sicher und leistungsfähig bleibt.",
          },
          {
            q: "Kann ich die Inhalte meiner Website selbst verwalten?",
            a: "Natürlich. Jede Website wird mit einem benutzerfreundlichen Admin-Panel geliefert, über das Sie Texte und Bilder ganz einfach ohne Programmierkenntnisse ändern können.",
          },
          {
            q: "Sind die Websites für Google (SEO) optimiert?",
            a: "Ja, die Suchmaschinenoptimierung (SEO) ist ein fester Bestandteil jedes Projekts. Wir sorgen dafür, dass Ihre Seite technisch optimal für Google vorbereitet ist.",
          },
          {
            q: "Wie sieht Ihre Rückerstattungsrichtlinie aus?",
            a: "Bei Vizioni Digjital bieten wir eine vollständige Rückerstattung an, falls wir das Projekt nicht gemäß den vorab vereinbarten Spezifikationen liefern.",
          },
        ],
      },
      testimonials: {
        title: "Was unsere Kunden sagen",
        sub: "Ihr Erfolg ist unser bester Beweis.",
        viewAll: "Alle ansehen",
        items: [
          {
            name: "Agim Krasniqi",
            role: "CEO, TechKos",
            text: "Vizioni Digjital hat genau verstanden, was wir brauchten. Unsere neue Website hat unsere Leads in nur einem Monat verdoppelt. Sehr engagiertes Team!",
          },
          {
            name: "Besnik Hoxha",
            role: "Direktor, AutoKosova",
            text: "Das System ist unglaublich schnell und einfach zu bedienen. Es spart uns jeden Tag Stunden an Arbeit und die Verkäufe sind deutlich gestiegen.",
          },
          {
            name: "Elena K.",
            role: "Gründerin, Boutique",
            text: "Wunderschönes Design und hervorragende SEO-Optimierung. Neue Kunden finden uns über Google-Suchen leichter denn je.",
          },
        ],
      },
      chat: {
        title: "Schreiben Sie uns",
        name: "Vorname",
        surname: "Nachname",
        username: "Username",
        email: "Email",
        msg: "Wie können wir helfen?",
        sentAs: "Gesendet als:",
        screenshotLabel: "Screenshot hinzufügen",
        uploadScreenshot: "Foto hochladen",
        imageSelected: "Bild gewählt ✅",
        send: "Senden",
        sending: "Senden...",
        success: "Gesendet! 🚀",
        placeholder: "Fragen Sie z. B.: 'Wie viel kostet der Growth-Plan?'",
        aiTab: "KI-Unterstützung",
        contactTab: "Schreiben Sie uns",
        badgeAi: "Digitaler Assistent",
      },
      tracker: {
        title: "Trends",
        titleAccent: "Entwicklung.",
        sub: "Entdecken Sie unsere erstklassigen Websites und modernen Entwicklungsprojekte.",
        viewAll: "Alle ansehen",
        filters: {
          all: "Alle",
          web: "Web",
          mobile: "Mobile",
          ai: "KI",
          restaurant: "Gastronomie",
          ecommerce: "E-Commerce",
          business: "Business",
          portfolio: "Portfolio",
          templates: "Vorlagen",
          branding: "Branding",
          design: "Design",
        },
        sort: {
          popular: "Beliebteste",
          newest: "Neueste",
          seo: "SEO-Bewertung",
        },
        searchPlaceholder: "Projekte oder Vorlagen suchen...",
        noProjects: "Keine Projekte gefunden.",
        description: "Beschreibung",
        reviews: "Bewertungen",
        addReview: "Bewertung hinzufügen",
        noReviews: "Noch keine Bewertungen. Sei der Erste!",
        rating: "Bewertung",
        commentPlaceholder: "Schreiben Sie Ihre Gedanken...",
        send: "Senden",
        cancel: "Abbrechen",
        loginToLike: "Bitte loggen Sie sich ein, um zu liken.",
        loginToReview: "Bitte loggen Sie sich ein, um zu bewerten.",
        iframeWarning: {
          title: "Ansichtsproblem?",
          text: "Falls die Seite oben nicht geladen wird, blockieren Sicherheitsplattformen möglicherweise die Einbindung (iFrame).",
          link: "Klicken Sie hier, um sie direkt aufzurufen.",
        },
        livePreview: {
          title: "Live-Vorschau",
          note: "Das Website-Design kann sich innerhalb des Rahmens ändern.",
        },
      },
      insights: {
        title: "Unser Blog",
        subtitle: "Insights & Artikel, die inspirieren",
        viewAll: "Alle ansehen",
        readOtherArticles: "Weitere Artikel lesen",
        articles: [
          {
            title: "10 Webdesign-Trends für 2024",
            date: "10. Mai 2024",
            tag: "WEBDESIGN",
          },
          {
            title: "So wachsen Sie auf Social Media",
            date: "8. Mai 2024",
            tag: "MARKETING",
          },
          {
            title: "SEO Best Practices für ein besseres Ranking",
            date: "3. Mai 2024",
            tag: "SEO",
          },
        ],
      },
      profile: {
        title: "Profil",
        logout: "Abmelden",
      },
      common: {
        login: "Login",
        loading: "Lädt...",
      },
      seo: {
        defaultTitle: "Vizioni Digjital | Webdesign Kosovo & Individuelle Softwareentwicklung Agentur",
        homeDesc:
          "Vizioni Digjital ist Ihre führende Agentur für professionelles Webdesign, individuelle Softwareentwicklung in Kosovo, E-Commerce Online-Shops und SEO-Optimierung.",
        homeKeywords:
          "webdesign kosovo, individuelle softwareentwicklung, e-commerce shop entwicklung, professionelle SEO optimierung, webanwendung programmieren, softwarefirma kosovo, vizioni digjital",
        aboutTitle: "Über uns",
        aboutDesc:
          "Erfahren Sie mehr über die Geschichte von Vizioni Digjital und unsere Mission als Technologie-Partner.",
        workTitle: "Wie wir arbeiten",
        workDesc:
          "Entdecken Sie unseren transparenten 4-stufigen Entwicklungsprozess und erkunden Sie unsere kreativen Projekte.",
        contactTitle: "Kontakt",
        contactDesc:
          "Kontaktieren Sie uns für professionelle Webentwicklung und maßgeschneiderte KI-Lösungen.",
        servicesTitle: "Dienstleistungen",
        servicesDesc:
          "Professionelles Webdesign, mobile Apps und KI-Automatisierung, maßgeschneidert für Ihr Unternehmen.",
        pricingTitle: "Pläne & Preise",
        pricingDesc:
          "Wählen Sie den idealen Plan für Ihr Unternehmen. Von Basispaketen bis hin zu fortschrittlichen Enterprise-Lösungen.",
        templatesTitle: "Unsere Vorlagen & Systeme",
        templatesDesc:
          "Durchsuchen Sie unsere Bibliothek mit Premium-Vorlagen und gebrauchsfertigen Systemen für Unternehmen.",
        blogTitle: "Blog & Einblicke",
        blogDesc:
          "Aktuelle Technologie-News, SEO-Tipps und Strategien für digitales Wachstum.",
        privacyTitle: "Datenschutzrichtlinie",
        termsTitle: "Nutzungsbedingungen",
        refundTitle: "Rückerstattungsrichtlinie",
        legalDesc:
          "Lesen Sie die {{title}} von Vizioni Digjital. Wir setzen uns für Transparenz und Sicherheit ein.",
      },
      legal: {
        privacy: {
          title: "Datenschutzrichtlinie",
          content: `
            <div class="prose prose-invert max-w-none">
              <h2>1. Einführung</h2>
              <p>Willkommen bei Vizioni Digjital. Wir verpflichten uns, Ihre Privatsphäre und Ihre persönlichen Daten zu schützen. Diese Datenschutzrichtlinie informiert Sie darüber, wie wir Ihre persönlichen Daten beim Besuch unserer Website schützen und klärt Sie über Ihre Datenschutzrechte auf.</p>

              <h2>2. Daten, die wir sammeln</h2>
              <p>Wir können verschiedene Arten von personenbezogenen Daten über Sie sammeln, verwenden, speichern und übertragen, einschließlich:</p>
              <ul>
                <li><strong>Identitätsdaten:</strong> Vorname, Nachname, Benutzername oder ähnliche Kennung.</li>
                <li><strong>Kontaktdaten:</strong> Rechnungsadresse, E-Mail-Adresse und Telefonnummern.</li>
                <li><strong>Technische Daten:</strong> Internetprotokoll-Adresse (IP), Ihre Anmeldedaten, Browsertyp und -version, Zeitzoneneinstellung und Standort, Arten und Versionen von Browser-Plug-ins, Betriebssystem und Plattform sowie andere Technologien auf den Geräten, mit denen Sie auf diese Website zugreifen.</li>
                <li><strong>Nutzungsdaten:</strong> Informationen darüber, wie Sie unsere Website, Produkte und Dienstleistungen nutzen.</li>
              </ul>

              <h2>3. Wie wir Ihre Daten verwenden</h2>
              <p>Wir werden Ihre personenbezogenen Daten nur dann verwenden, wenn das Gesetz es uns erlaubt. Am häufigsten werden wir Ihre personenbezogenen Daten unter folgenden Umständen verwenden:</p>
              <ul>
                <li>Wenn wir den Vertrag erfüllen müssen, den wir mit Ihnen abschließen oder bereits abgeschlossen haben.</li>
                <li>Wenn es für unsere berechtigten Interessen erforderlich ist und Ihre Interessen und Grundrechte diese Interessen nicht überwiegen.</li>
                <li>Wenn wir einer gesetzlichen oder behördlichen Verpflichtung nachkommen müssen.</li>
              </ul>

              <h2>4. Datensicherheit</h2>
              <p>Wir haben angemessene Sicherheitsvorkehrungen getroffen, um zu verhindern, dass Ihre persönlichen Daten versehentlich verloren gehen, in unbefugter Weise verwendet oder auf diese zugegriffen wird, verändert oder offengelegt werden. Darüber hinaus beschränken wir den Zugriff auf Ihre persönlichen Daten auf diejenigen Mitarbeiter, Vertreter und sonstige Dritte, die dies aus geschäftlichen Gründen wissen müssen.</p>

              <h2>5. Zahlungen und Stripe-Datenschutz</h2>
              <p>Wir verwenden <strong>Stripe</strong> für die Zahlungsabwicklung. Wir speichern keine Kredit- oder Debitkartendaten auf unseren Servern. Alle Zahlungsinformationen werden von Stripe sicher verarbeitet und gespeichert. Wenn Sie unsere Dienste nutzen, stimmen Sie auch der Datenschutzrichtlinie von Stripe zu, die Sie unter <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">stripe.com/privacy</a> finden.</p>

              <h2>6. Datenspeicherung</h2>
              <p>Wir werden Ihre personenbezogenen Daten nur so lange aufbewahren, wie es erforderlich ist, um die Zwecke zu erfüllen, für die wir sie gesammelt haben, einschließlich zur Erfüllung gesetzlicher, buchhalterischer oder Berichtsanforderungen.</p>

              <h2>7. Cookies und Google AdSense</h2>
              <p>Unsere Seite verwendet "Cookies", um die Benutzererfahrung zu verbessern. Wir können Google AdSense verwenden, um Werbung anzuzeigen. Google verwendet als Drittanbieter Cookies zur Schaltung von Anzeigen auf unserer Website. Durch die Verwendung des DART-Cookies kann Google unseren Nutzern basierend auf ihrem Besuch auf unserer Website und anderen Websites im Internet Anzeigen schalten.</p>

              <h2>8. Ihre Rechte</h2>
              <p>Unter bestimmten Umständen haben Sie datenschutzrechtliche Rechte in Bezug auf Ihre persönlichen Daten, einschließlich des Rechts auf Auskunft, Berichtigung, Löschung, Einschränkung, Übertragung und Widerspruch gegen die Verarbeitung.</p>
            </div>
          `,
        },
        terms: {
          title: "Nutzungsbedingungen",
          content: `
            <div class="prose prose-invert max-w-none">
              <h2>1. Annahme der Bedingungen</h2>
              <p>Indem Sie auf die Website von Vizioni Digjital zugreifen und diese nutzen, akzeptieren Sie diese Vereinbarung und stimmen zu, an ihre Bedingungen gebunden zu sein. Wenn Sie diesen Bedingungen nicht zustimmen, nutzen Sie unseren Service bitte nicht.</p>

              <h2>2. Leistungsbeschreibung</h2>
              <p>Vizioni Digjital bietet Webentwicklung, mobile Anwendungen, Grafikdesign und Lösungen für Künstliche Intelligenz an. Wir behalten uns das Recht vor, den Dienst mit oder ohne vorherige Ankündigung zu ändern oder einzustellen.</p>

              <h2>3. Pflichten des Nutzers</h2>
              <p>Als Nutzer sind Sie dafür verantwortlich, die Vertraulichkeit Ihres Kontos und Passworts zu wahren. Sie stimmen zu, Vizioni Digjital unverzüglich über jede unbefugte Nutzung Ihres Kontos zu informieren.</p>

              <h2>4. Geistiges Eigentum</h2>
              <p>Alle auf dieser Website enthaltenen Inhalte wie Texte, Grafiken, Logos, Schaltflächensymbole, Bilder und Software sind Eigentum von Vizioni Digjital oder seinen Inhaltslieferanten und durch internationale Urheberrechtsgesetze geschützt.</p>

              <h2>5. Haftungsbeschränkung</h2>
              <p>Vizioni Digjital haftet nicht für direkte, indirekte, zufällige, Folge- oder exemplarische Schäden, die sich aus der Nutzung oder der Unmöglichkeit der Nutzung unseres Services ergeben.</p>

              <h2>6. Änderungen der Bedingungen</h2>
              <p>Wir behalten uns das Recht vor, diese Bedingungen jederzeit zu ändern. Die fortgesetzte Nutzung der Website nach solchen Änderungen stellt Ihre Zustimmung zu diesen Änderungen dar.</p>

              <h2>7. Geltendes Recht</h2>
              <p>Diese Bedingungen unterliegen den Gesetzen der Republik Albanien und Kosovo und werden in Übereinstimmung mit diesen ausgelegt, ohne Rücksicht auf deren Kollisionsnormen.</p>
            </div>
          `,
        },
        refund: {
          title: "Rückerstattungsrichtlinie",
          content: `
            <div class="prose prose-invert max-w-none">
              <h2>1. Allgemeine Richtlinie</h2>
              <p>Bei Vizioni Digjital sind wir bestrebt, Dienstleistungen von höchster Qualität anzubieten. Wir verstehen jedoch, dass es Umstände geben kann, unter denen eine Rückerstattung erforderlich ist.</p>

              <h2>2. Entwicklungsdienstleistungen (Web & Apps)</h2>
              <p>Aufgrund der Art von maßgeschneiderten Entwicklungsdiensten werden Rückerstattungen wie folgt bearbeitet:</p>
              <ul>
                <li><strong>Vor Arbeitsbeginn:</strong> 100% volle Rückerstattung.</li>
                <li><strong>Während der Designphase:</strong> Bis zu 50% Rückerstattung des gezahlten Betrags.</li>
                <li><strong>Nach Beginn der Code-Entwicklung:</strong> Aufgrund der aufgewendeten Arbeitsstunden werden keine Rückerstattungen gewährt.</li>
              </ul>

              <h2>3. Digitale Produkte und Abonnements</h2>
              <p>Für digitale Produkte (wie Vorlagen) oder Abonnementpläne (Launch, Growth, Enterprise) müssen Rückerstattungsanfragen innerhalb von 7 Tagen nach dem ursprünglichen Kauf gestellt werden, vorausgesetzt, es wurde kein Material heruntergeladen oder in großem Umfang genutzt.</p>

              <h2>4. Rückerstattungsprozess</h2>
              <p>Alle Rückerstattungsanfragen müssen schriftlich an vizionidigjital@gmail.com gesendet werden. Bitte geben Sie Ihre Bestellnummer und einen detaillierten Grund für Ihre Anfrage an. Rückerstattungen werden innerhalb von 10-15 Werktagen nach Genehmigung wieder auf die ursprüngliche Zahlungsmethode gutgeschrieben.</p>

              <h2>5. Kosten von Drittanbietern</h2>
              <p>Bitte beachten Sie, dass Kosten von Drittanbietern (wie Domainnamen, Stripe-Transaktionsgebühren oder Softwarelizenzen) nicht erstattungsfähig sind.</p>
            </div>
          `,
        },
      },
      payment: {
        title: "Zahlung",
        instruction:
          "Scannen Sie den QR-Code oder folgen Sie den Schritten für die manuelle Zahlung.",
        stripeTitle: "Stripe Checkout",
        stripeDesc:
          "Klicken Sie unten, um sicher zur Stripe-Kasse zu gelangen. Visa, Mastercard und andere wichtige Optionen werden unterstützt.",
        payWithCard: "Mit Karte bezahlen",
        connecting: "Verbindung wird hergestellt...",
        oneForTitle: "OneFor Apps",
        cta1: "OneFor öffnen",
        cta2: "Screenshot senden",
        footer: "Kontaktieren Sie uns bei Problemen.",
        disclaimer: "* Ihre Sicherheit ist unsere Priorität.",
        securedBy: "Gesichert durch Stripe",
        upgradeBadge: "PROJEKT-UPGRADE / ERWEITERUNG",
        upgradeTitle: "Projekt-Upgrade-Gebühr",
        upgradeDescription:
          "Benötigen Sie zusätzliche Phasen, kundenspezifische Integrationen oder erhöhte Kapazitäten für Ihr Projekt? Hier können Sie jeden vereinbarten Betrag bezahlen, um mit dem Upgrade Ihres Projekts fortzufahren.",
        upgradePriceLabel: "Zahlungsbetrag",
        upgradePrice: "Individuell (Beliebiger Betrag)",
        upgradeCta: "Jetzt bezahlen",
        upgradeBullet1: "Einmalige Zahlung",
        upgradeBullet2: "Sicherer Checkout",
        upgradeBullet3: "Sofortige Verarbeitung",
      },
      footer: {
        desc: "Wir entwickeln digitale Lösungen, die Unternehmen weltweit stärken.",
        address: "Mitrovica, Suhodoll, Kosovo",
        phone: "+383 49 558 803",
        newsletter: "Newsletter",
        newsSub: "Abonnieren Sie die neuesten Updates.",
        emailPlaceholder: "Ihre E-Mail",
        rights: "© 2026 Vizioni Digjital. Alle Rechte vorbehalten.",
        followUs: "Folgen Sie uns:",
      },
      admin: {
        title: "Admin",
        titleAccent: "Dashboard.",
        logout: "Abmelden",
        accessDenied: "Zugriff verweigert",
        accessDeniedSub: "Nur Administratoren können diese Seite sehen.",
        stats: {
          totalMessages: "Nachrichten",
          unread: "Ungelesen",
          liveProjects: "Projekte",
          paymentConfirmations: "Zahlungen",
        },
        tabs: {
          messages: "Nachrichten",
          projects: "Projekte",
          users: "Benutzer",
        },
        messages: {
          replyEmail: "E-Mail antworten",
          replySubject: "Antwort von Vizioni Digjital",
          replyBody: "Hallo {{name}},...",
          confirmPayment: "Zahlung bestätigen",
          paymentSubject: "Zahlungsbestätigung - Vizioni Digjital",
          paymentText:
            "Hallo {{name}}, Ihre Zahlung wurde erfolgreich bestätigt.",
          markAsRead: "Als gelesen markieren",
          markAsUnread: "Als ungelesen markieren",
          delete: "Löschen",
          confirmDelete: "Löschen bestätigen",
          cancel: "Abbrechen",
          screenshotConfirmation: "Screenshot Bestätigung",
        },
        addProject: {
          title: "Projekt hinzufügen",
          submit: "Speichern",
        },
        users: {
          plan: "Plan",
          expiry: "Ablauf",
          status: "Status",
          save: "Speichern",
        },
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["querystring", "cookie", "localStorage", "navigator", "htmlTag"],
      caches: ["localStorage", "cookie"],
    },
  });

export default i18n;
